import {
  Local,
  Category_Time,
  Section_Time
} from "./../../services/question.service";
import { Category } from "./../../services/login.service";
import {
  Component,
  OnInit,
  Renderer2,
  HostListener,
  ViewChild,
  ElementRef,
  TemplateRef,
  Inject,
  NgZone,
  Injectable,
  NgModule,
  Input
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";
import { MatIconRegistry } from "@angular/material/icon";
import { HttpClient } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { switchMap, takeUntil, catchError } from "rxjs/operators";
import "rxjs/add/observable/timer";
import "rxjs/add/operator/map";
import "rxjs/add/operator/take";
import { Pipe, PipeTransform } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import * as _ from "lodash";
import { formatDate } from "@angular/common";
//import {MathjaxComponent} from '../mathjax/mathjax.component';
import { MathJaxDirective } from "./mathjax.directive";
import * as moment from "moment";
import Swal from "sweetalert2";
import { userDetailsService } from "src/app/services/user.details.service";
import {
  faFilter,
  faPauseCircle,
  faHome,
  faAngleLeft,
  faAngleRight,
  faInfoCircle,
  faPencilAlt
} from "@fortawesome/free-solid-svg-icons";
import { Router, ActivatedRoute, CanActivate } from "@angular/router";
import { Question, questionService } from "src/app/services/question.service";
import { MatTabChangeEvent } from "@angular/material/tabs";
import { FormControl, FormGroup } from "@angular/forms";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { SaveModel, SaveEssay } from "./logicaltest.model";
import { LocationStrategy } from "@angular/common";
import { timer, Observer } from "rxjs";
import { THIS_EXPR } from "@angular/compiler/src/output/output_ast";
// import { DraggableComponent } from '../draggable/draggable.component';
import { ConfigService, evaluate_user } from "src/app/services/config.service";
import {
  endtestService,
  Endtest,
  Check_log_value
} from "src/app/services/endtest.service";
import { data } from "jquery";
import { Console } from "console";
import { __spreadArrays } from "tslib";

declare var $: any;
declare let jQuery: any;

@Component({
  selector: "app-logicaltest",
  templateUrl: "./logicaltest.component.html",
  styleUrls: ["./logicaltest.component.scss"],

  styles: [
    `
      .redClass {
        background-color: red;
      }
    `
  ]
})
@Injectable()
export class LogicaltestComponent implements OnInit, CanActivate {
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild("finish") modalFinish: ElementRef;
  @ViewChild("keyboard") modalKeyboard: TemplateRef<any>;
  @ViewChild("Start") modalStart: TemplateRef<any>;
  @ViewChild("Capture") modalCapture: TemplateRef<any>;
  @ViewChild("rightclick") modalRightClick: TemplateRef<any>;
  @ViewChild("imagePreview") modalImagePreview: TemplateRef<any>;
  @ViewChild("timeralert") modalTimerAlert: TemplateRef<any>;
  @ViewChild("alert", { static: true }) alert: ElementRef;
  @ViewChild("myroughspace") modalRoughspace: TemplateRef<any>;
  @ViewChild("text") text: ElementRef;
  @ViewChild("video")
  public video: ElementRef;

  @ViewChild("canvas")
  public canvas: ElementRef;
  WIDTH = 450;
  HEIGHT = 450;
  //@ViewChild(MathjaxComponent) childView: MathjaxComponent;
  @ViewChild("equation") equation: ElementRef;
  @Input(" MathJax")
  @Input("MathJax")
  fractionString: string;
  elem;
  // essay_str = Array<{ essay: string; questionid: number }>();
  essay_str = new Map<string, Array<any>>();
  save_essay = new Map<string, Array<any>>();
  tempQuestionIdArray = new Map<string, any>();
  // save_essay: Array<SaveEssay> = [];
  toggleClass = "ft-minimize";
  today = new Date();
  todaysDataTime = "";
  public config: any = {};
  eee: boolean;
  input: any;
  func: any;
  textValue: string = "";
  taker_id: any;
  showModal5: boolean;
  showModal1: boolean;
  showModal2: boolean;
  showModal: boolean;
  zero: number = 0;
  n: any;
  caretPos: number = 0;
  isLoading:boolean= false;
  // roughspace: boolean=false;
  //word count
  public remainingWords = 5;

  public textareaForm = new FormGroup({
    textinput: new FormControl()
  });
  str: string;
  Fullscreen: any;
  buttonclick: boolean = false;
  checked: boolean = false;
  public isEnding: boolean = false;
  public isFiltering: boolean = true;
  section: any[] = [];
  closeResult: string;
  row_question: string;
  season_question: string;
  currentCheckedValue = null;
  cat_Id;
  radio_ques_id;
  radio_ans_id;
  type_ques_id: string;
  essay_id: string;
  sample = 20;
  id;
  set;
  paper;
  unanswered;
  visited_count;
  answered: number = 0;
  question: Question = {
    questionId: "",
    question_text: "",
    answerId: "",
    Answer_Text: "",
    Duration: ""
  };
  check_loggedin: Check_log_value = {
    Test_Taker_User_Id: "",
    schedule_id: ""
  };
  user_id: evaluate_user = {
    id: ""
  };
  // cat_set: Local = {
  //   Id: '',
  //   set: '',
  //   paper: ''
  // };
  temp_ques_id: any;
  questions: any;
  time: number = 0;
  myTime: any = 0;
  time_to_capture: any;
  total: number;
  answer: any;
  currentCategoryQuestionlength: any;
  filter_answer_id: any;
  filter_answer_id1: any;
  category: any;
  // questionIdarray = [];
  questionTypearray = [];
  questionIdarray = new Map<string, any>();
  //submit_final = new Array(this.length1);
  // save_answer = Array<{ roughspace: boolean; explanation: any; answerid: number; questionid: number;user_id : number;
  // schedule_id : number, username : any}>();
  save_answer = new Map<string, Array<any>>();
  prevSelectedAnswerArray = new Map<string, Array<any>>();
  prevSelectedAnswer = null;
  qid = [];
  // visitedArray= Array<{value:boolean;i:number}>();
  //visitedArrays=Array<{value:boolean;i:number}>();
  visitedArrays: any = [];
  visitedArray: any = [];
  fill: any = [];
  visited: any = [];
  filter = [];
  local: Local = {
    Id: "",
    paper: "",
    set: "",
    schedule: "",
    email: "",
    schedule_master_Id: ""
  };
  category_time: Category_Time = {
    start_time: "",
    end_time: "",
    category_id: "",
    user_id: ""
  };
  section_time: Section_Time = {
    start_time: "",
    end_time: "",
    section_name: "",
    user_id: "",
    email: "",
    category_id: ""
  };
  // submit: Array<SaveModel> = [];
  submit = new Map<string, Array<any>>();
  fname: any;
  countDown: any;
  counter: any;
  tick = 1000;
  cat: any;
  button_click: boolean = true;
  comprehension_button_click: boolean = true;
  select: any = [];
  islogged: Endtest = {
    Id: "",
    Test_Taker_User_Id: "",
    Is_Logged: "",
    login_time: "",
    logoff_time: "",
    schedule_master_Id: ""
  };
  MCQUnanswered = 0;
  comprehensionUnanswered = 0;

  words: any = [];
  wordCount: any;
  myvar: boolean = false;
  fCount: number;
  captures: string[] = [];
  isCaptured: boolean;
  public url: any;
  focuscount: number = 0;
  private fn: Function;
  crt_value: any;
  color: any = "Violet";
  visited_value: boolean = true;
  i: number = 0;
  activeTab = 0;
  activeSubTab = 0;
  visitedComprehensionTab: any = [];
  temp1 = `q${this.i}`;
  temp = `q${this.questionIdarray}`;
  displayQuestionsArray = [];
  comprehensionQuestionsArray = [];
  answeredAllComprehensionQns = [];
  answeredAllComprehensionQnsFreeText = [];
  answerAllComprehension = [];
  answerType: any;
  previousValue: any;
  save_individual_ans_array = [];
  selectedQuestionId: any;
  prevQuestionId: any;
  compArray = [];
  arrlength: any;
  summa: any;
  section_button: any;
  roughspace: any;
  roughspace_filter: any = [];
  book_mark: any = [];
  end_button: any = [];
  start_time: string;
  category_start_time: string;
  arr: any;
  essay_ques_length: any;
  length: any;
  essay: boolean;
  not_essay: boolean;
  isAudioQuestion: [];
  ques_index: any;
  esarr = [];
  wordc: any;
  roughspace_flag: any = [];
  visit: any = 0;
  total_questions;
  stopblink: boolean;
  base64Image: any;
  currentThumbnail: any;
  // sanitizer: any;
  dir: any;
  sectioncount: any;
  sectioncounter: any;
  keypress: boolean = false;
  delkeypress: boolean = false;
  lastPos: number = 0;
  user_logon_time: string;
  user_loggoff_time: string;
  logged: boolean;
  error: any;
  timer: any;
  timer_alert: any;
  timing: any;
  hourglass: boolean = false;
  timings: any;
  z;
  fractionString1: any = [];
  modalRef: any;
  modalCafe: any;
  displayname: string;
  categoryduration: any;
  escapetime: number;
  escape_count: number = 0;
  popupcounter: number = 0;
  pagealive: number = 0;
  datenow: number;
  date: Date;
  // temp1 = `q${this.i}`;
  // Kill subject to stop all requests for component
  private killTrigger: Subject<void> = new Subject();
  question_length: any;
  selectedFreeTextComprehensionIndex = 0;
  code_Pos: number;
  code_tabpress: number = 0;
  Section_Id: any;
  first_question: any;
  tab_counter: number = 0;
  userId: string;
  email: string;
  schedule_id: string;
  bookmark_counter: number = 0;
  // questioncounter: boolean = false;
  products: { category_Id: number; ProductId: number; Product_name: string }[];
  answer_text: any;
  imageQuestion: boolean;
  isOpenEndedQuestions: boolean;
  showTextArea: any = [];
  currentQuestionType: any;
  previousSelectedTabIndex: any = [];
  evaluateMCQ: boolean;
  localstream: any;
  comprehensionTabColor = [];
  falseResponseIdsMCQ = [];
  falseResponseIdsFreeText = [];
  array: any[];
  combinedIndividualAnsArray: any[];
  user_answers: any;
  user_essay_answers: any;

  flagForCount = false;

  zeroIndexCounter = 0;
  isComprehensionContainBoth: boolean = false;
  totalCount: number = 0;
  mcqCount: number = 0;
  ftCount: number = 0;

  countOfCallingDefaultCounter: number = 0;

  isCustomStyleApplied: boolean = false;
  screenWidth: number | undefined;
  screenHeight: number | undefined;

  noneTypeQuestions: any[] = [];
  showQuestionModal: boolean = false;
  selectedQuestion: any = null;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private ren: Renderer2,
    private location: LocationStrategy,
    private route: ActivatedRoute,
    private quest: questionService,
    public router: Router,
    iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private httpClient: HttpClient,
    private modal: NgbModal,
    private ngZone: NgZone,
    private modalService: NgbModal,
    private config1: ConfigService,
    private evaluate_user: endtestService,
    private Endtest: endtestService,
    private el: ElementRef,
    private userDetails: userDetailsService
  ) {
    iconRegistry.addSvgIcon(
      "thumbs-up",
      sanitizer.bypassSecurityTrustResourceUrl("assets/filter_list.svg")
    );
  }
  canActivate(
    route: import("@angular/router").ActivatedRouteSnapshot,
    state: import("@angular/router").RouterStateSnapshot
  ):
    | boolean
    | import("@angular/router").UrlTree
    | Observable<boolean | import("@angular/router").UrlTree>
    | Promise<boolean | import("@angular/router").UrlTree> {
    throw new Error("Method not implemented.");
  }
  public ngOnInit() {
   
    const self = this;

    this.escapetime = 80000;
    this.sectioncount = JSON.parse(localStorage.getItem("section_counter"));
    this.fname = sessionStorage.getItem("fname");

    this.userId = sessionStorage.getItem("id");
    this.email = sessionStorage.getItem("email");
    this.schedule_id = sessionStorage.getItem("Schedule_Id");

    this.countOfCallingDefaultCounter = 0;

    MathJax.Hub.Config({
      showMathMenu: false,
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"]
        ]
      },
      menuSettings: { zoom: "Double-Click", zscale: "150%" },
      CommonHTML: { linebreaks: { automatic: true } },
      "HTML-CSS": {
        scale: 100,
        linebreaks: { automatic: true, width: "container" }
      },
      SVG: { linebreaks: { automatic: true } }
    });
    setTimeout(() => {
      MathJax.Hub.Queue([
        "Typeset",
        MathJax.Hub,
        document.getElementsByClassName("answers")
      ]);
    }, 1000);

    this.escapetime = 80000;

    this.previousSelectedTabIndex.push(0);

    this.sectioncount = JSON.parse(localStorage.getItem("section_counter"));
    jQuery(document).ready(function($) {
      if (window.history && window.history.pushState) {
        $(window).on("popstate", function() {
          var hashLocation = location.hash;
          var hashSplit = hashLocation.split("#!/");
          var hashName = hashSplit[1];

          if (hashName !== "") {
            var hash = window.location.hash;
            if (hash === "") {
            }
          }
        });

        window.history.pushState("/", null, "./");
      }
    });

    $(window).unload(function() {
      Swal.fire({
        title: "Alert",
        text: "Unload ",
        icon: "warning",
        showCancelButton: false,
        confirmButtonText: "OK"
      }).then(result => {
        if (result.isConfirmed) {
        }
      });
    });

    var focuscount = 0;
    var fCount;
    // const modalRef = this.modal.open(this.modalContent)

    if (document.hasFocus()) {
    } else {
      // alert("Using other applications");
      focuscount += 1;
    }

    document.addEventListener("visibilitychange", function() {
      if (document.hidden) {
        //alert('popup')

        focuscount += 1;

        if (fCount >= 3) {
          //finalclose();
        }
      }
    });

    this.elem = document.documentElement;
    this.route.params.subscribe(params => {
      this.Section_Id = params["id"];
      this.cat_Id = this.id;
      this.cat = localStorage.getItem("Category-id");
      this.set = localStorage.getItem("Set-id");
      this.paper = localStorage.getItem("Paper-id");
    });

    this.displayname = localStorage.getItem("display_name");

    this.categoryduration = localStorage.getItem("categoryduration");
    this.local.Id = this.Section_Id;
    this.local.set = sessionStorage.getItem("Set_Id");
    this.local.paper = sessionStorage.getItem("Paper_Id");
    this.local.schedule = sessionStorage.getItem("Schedule_Id");
    this.local.email = sessionStorage.getItem("email");
    this.local.schedule_master_Id = sessionStorage.getItem(
      "Schedule_Master_Id"
    );
    this.getScreenSize();
    this.applyStylesBasedOnResolution();
    this.displayQuestions();
  }
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
    
    this.screenHeight = window.innerHeight;
   
  }

  applyStylesBasedOnResolution(): void {
    if (this.screenWidth && this.screenHeight) {
     
      if (this.screenWidth < 1366 && this.screenHeight < 768) {
        this.isCustomStyleApplied = true;
      }
    }
  }

  async getQuestion() {
    this.questions = [];

    return new Promise((resolve, reject) => {
      this.quest.displayQuestion(this.local).subscribe(
        async data => {
          console.log("Questions to display",data)
          this.questions = await data.results;
          this.answer = data.resultanss = await data.resultanss;

          this.question_length = this.questions.length;

          resolve(this.questions);
        },
        err => {
          reject(err);
        }
      );
    });
  }

  checkForMultipleNoneTypeQuestions(): void {
    this.noneTypeQuestions = this.questions.filter(q => q.type_name === "None");

    if (this.noneTypeQuestions.length > 1) {
      this.showQuestionModal = true;
    } else if (this.noneTypeQuestions.length === 1) {
      this.selectedQuestion = this.noneTypeQuestions[0];
    }
  }

  onQuestionModalClosed(selectedQuestion: any): void {
    console.log("Modal closed with selection:", selectedQuestion);
    this.showQuestionModal = false;
    if (selectedQuestion) {
      this.selectedQuestion = selectedQuestion;
    } else {
      // User cancelled - force them to select
      alert("Please select a question to continue");
      setTimeout(() => (this.showQuestionModal = true), 500);
    }
  }

  async displayQuestions() {
    console.log("inside displayquestions", this.local, this.user_id, this.cat);

    this.questions = await this.getQuestion();
	this.checkForMultipleNoneTypeQuestions();
    while (this.showQuestionModal) {
      await new Promise(resolve => setTimeout(resolve, 100));
    }	

    this.first_question = this.selectedQuestion || this.questions[0];
    this.selectedQuestionId = `q${this.first_question.Id}`;

    this.question_length = this.questions.length;
    for (var i = 0; i < this.questions.length; i++) {
      this.fractionString1.push(this.questions[i].Question_Text);
      if(this.questions[i].type_name == "Algorithm"){
        this.questions[i].Question_Text = this.questions[i].Question_Text.replace(/\\n/g, '\n');
      }
    }

    if (
      this.questions[0].type_name == "None" ||
      this.questions[0].type_name == "Algorithm"
    ) {
      this.essay = true;
      this.isOpenEndedQuestions = true;
      this.length = this.selectedQuestion ? 1 : this.questions.length;
      this.unanswered = this.length;
    } else {
      console.log("inisde not essay");
      this.not_essay = true;
    }

    if (this.selectedQuestion) {
      this.visited_count = 1
      this.displayQuestionsArray = [this.selectedQuestion];
      this.total_questions = 1; 
      this.question_length = 1;
      this.questions=[this.selectedQuestion];
      console.log("displayQuestionsArray", this.displayQuestionsArray);
    } else {
      this.displayQuestionsArray = await this.populateDisplayQues();
    }

    // let q_url = "initial";

    // for (let i = 0; i < this.questions.length; i++) {
    //   if (
    //     this.questions[i].type_name == "Comprehension With MCQ" ||
    //     this.questions[i].type_name == "Comprehension With Free Text"
    //   ) {
    //     if (q_url == "initial") {
    //       this.compArray.push(this.questions[i]);
    //       q_url = this.questions[i].q_url;
    //     } else {
    //       if (this.questions[i].q_url == q_url) {
    //         console.log("qurl is same");
    //         this.compArray.push(this.questions[i]);
    //         if (
    //           (this.questions[i + 1] &&
    //             this.questions[i + 1].type_name !=
    //               "Comprehension With MCQ" &&
    //             this.questions[i + 1].type_name !=
    //               "Comprehension With Free Text") ||
    //           i == this.questions.length - 1
    //         ) {
    //           console.log("compArray in final", i, this.compArray);
    //           this.displayQuestionsArray.push(this.compArray);
    //           this.comprehensionQuestionsArray.push(this.compArray);
    //           q_url = "initial";
    //           this.compArray = [];
    //         }
    //       } else {
    //         console.log("comp array pushed");
    //         this.displayQuestionsArray.push(this.compArray);
    //         this.comprehensionQuestionsArray.push(this.compArray);
    //         this.compArray = [];
    //         // console.log("q_url not equal")
    //         this.compArray.push(this.questions[i]);
    //         // console.log("compArray initial",this.compArray)
    //         q_url = this.questions[i].q_url;
    //       }
    //     }
    //   } else {
    //     console.log("no coprehension qa");
    //     this.displayQuestionsArray.push(this.questions[i]);
    //   }
    // }
    // console.log("end of for");
    // console.log("this.displayQuestionsArray", this.displayQuestionsArray);

    // this.comprehensionUnanswered = this.comprehensionQuestionsArray.length;
    // console.log("comprehensionUnanswered", this.comprehensionUnanswered);
    // this.total = this.displayQuestionsArray.length;
    // console.log("this.compArray", this.compArray);

    this.total_questions = this.displayQuestionsArray.length;
    console.log("questions", this.questions);
    console.log("total questions", this.total_questions);

    this.currentCategoryQuestionlength = this.displayQuestionsArray.length;

    for (var i = 0; i < this.currentCategoryQuestionlength; i++) {
      this.esarr[this.questions[i].Id] = null;
    }

    this.fname = sessionStorage.getItem("fname");
    // this.answer = data.resultanss;
    this.getCategory(this.questions[0].Question_Id);
    this.visited_count = this.currentCategoryQuestionlength - 1;
    console.log(
      "category duration initial value************",
      this.categoryduration
    );
    console.log("this.timer initial value**********", this.timer);
    console.log("timer_alert initial value", this.timer_alert);
    console.log("time initial value", this.time);
    console.log("counter initial value", this.counter);
    this.timer = this.categoryduration;

    this.timer_alert = (this.timer - 2) * 60000;
    this.time_to_capture = 10000;

    this.time = this.categoryduration * 60000; //m to ms

    this.counter = this.categoryduration * 60; //m to s

    console.log("category duration after setting", this.categoryduration);
    console.log("this.timer after setting", this.timer);
    console.log("timer_alert after setting", this.timer_alert);
    console.log("time after setting", this.time);
    console.log("counter after setting", this.counter);

    this.category = this.questions[0].Category_Name;
    this.currentQuestionType = this.questions[0].type_name;

    for (var i = 0; i < this.displayQuestionsArray.length; i++) {
      if (this.isArray(this.displayQuestionsArray[i])) {
        this.questionIdarray.set(
          `q${this.displayQuestionsArray[i][0].Id}`,
          this.displayQuestionsArray[i][0].Id
        );
        //  this.questionIdarray[i] = this.displayQuestionsArray[i][0].Id;
        this.questionTypearray[i] = this.displayQuestionsArray[i][0].type_name;
      } else {
        //  console.log("is not  array",)
        this.questionIdarray.set(
          `q${this.displayQuestionsArray[i].Id}`,
          this.displayQuestionsArray[i].Id
        );
        //  this.questionIdarray[i] = this.displayQuestionsArray[i].Id;
        this.questionTypearray[i] = this.displayQuestionsArray[i].type_name;
      }
    }

    for (var i = 0; i < this.displayQuestionsArray.length; i++) {
      if (!this.isArray(this.displayQuestionsArray[i])) {
        console.log(
          "inisde not array temp",
          `q${this.displayQuestionsArray[i]}.Id`
        );
        this.tempQuestionIdArray.set(
          `q${this.displayQuestionsArray[i].Id}`,
          this.displayQuestionsArray[i].Id
        );
      }
    }
    console.log("tempQuestionIdArray", this.tempQuestionIdArray);

    console.log("questionIdarray in ngonit", this.questionIdarray);

    console.log("selectedQuestionId inside ngoninit", this.selectedQuestionId);
    for (var i = 0; i < this.currentCategoryQuestionlength; i++) {
      var questionId;
      console.log(
        "this.displayQuestionsArray[i].Id",
        this.displayQuestionsArray[i].Id
      );
      if (this.isArray(this.displayQuestionsArray[i])) {
        console.log("is array");
        questionId = this.displayQuestionsArray[i][0].Id;
      } else {
        console.log("not array");
        questionId = this.displayQuestionsArray[i].Id;
      }
    }

    console.log("this.save_answer********", this.save_answer);

    for (var i = 0; i < this.questions.length; i++) {
      // this.filter[this.questionIdarray[i]] = false;
      this.filter[this.questions[i].Id] = false;
      this.prevSelectedAnswerArray.set(`q${this.questions[i].Id}`, [null]);
      // this.showTextArea[this.questionIdarray[i]] = true;
      this.showTextArea[this.questions[i].Id] = true;
      if (
        this.questions[i].type_name != "Free Text" &&
        this.questions[i].type_name != "Comprehension With Free Text" &&
        this.questions[i].type_name != "None" &&
        this.questions[i].type_name != "Algorithm"
      ) {
        var temp = `q${this.questions[i].Id}`;
        console.log("inside now******", this.questions[i].type_name, temp);
        this.save_answer.set(temp, [
          null,
          null,
          null,
          this.questions[i].Id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);
      }
      if (
        this.questions[i].type_name == "Free Text" ||
        this.questions[i].type_name == "Comprehension With Free Text" ||
        this.questions[i].type_name == "None" ||
        this.questions[i].type_name == "Algorithm"
      ) {
        var temp = `q${this.questions[i].Id}`;
        console.log(
          "inside now****** FREE TEXT",
          this.questions[i].type_name,
          temp
        );
        this.essay_str.set(temp, [
          null,
          this.questions[i].Id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);
      }
    }
    console.log("this.filter", this.filter);
    console.log("this.save_answer**ttt", this.save_answer);
    console.log("this.essayste**ttt", this.essay_str);

    this.unanswered = this.currentCategoryQuestionlength;
    this.myTime = null;
    this.timings = null;
    console.log("this.myTime initial value", this.myTime);
    console.log("timings initial value", this.timings);

    this.timings = setTimeout(() => {
      setTimeout(() => {
        // console.log("inisde settimeout")
        this.capture();
      }, this.time_to_capture);
    });
    this.timings = setTimeout(() => {
      let ngbModalOptions: NgbModalOptions = {
        backdrop: "static",
        keyboard: false
      };
      //Open modal on pressing escape
      const modalRef = this.modal.open(this.modalTimerAlert, ngbModalOptions);

      setTimeout(() => {
        modalRef.close(this.modalTimerAlert);
      }, 5000);
    }, this.timer_alert);

    this.myTime = setTimeout(() => {
      clearTimeout(this.escapetime);
      this.escapetime = 0;

      if (
        this.questions[0].type_name == "None" ||
        this.questions[0].type_name == "Algorithm"
      ) {
        this.save_essayanswer_count(); //save essay answer
      } else {
        this.end_test(); //save mcq
      }
      //this.modalRef.close(this.modalFinish);
      this.router.navigate(["section"]);
      this.modalCafe.close(this.modalContent);
    }, this.time);
    //},20000);
    this.countDown = Observable.timer(0, this.tick)
      .take(this.counter)
      .map(() => --this.counter);
    // console.log("this.countDown",this.countDown)
    console.log("this.myTime after setting", this.myTime);
    console.log("timings after setting", this.timings);
    await this.getUserAnsweredFreeText();
    await this.getUserAnsweredMCQ();

    return this.questions, this.questionIdarray;
  }

  async getUserAnsweredMCQ() {
    console.log("Inside getUserAnsweredMCQ");
    await this.quest
      .get_user_selected_answers(this.userId, this.schedule_id, this.Section_Id)
      .subscribe(async data => {
        console.log("user answer data", data);
        this.user_answers = await data.resultanss; //retrieve user mcq answer
        console.log("user ans len", this.user_answers.length);
        await this.populateQuestions();
        await this.setDefaultCount();
      });
  }

  async getUserAnsweredFreeText() {
    console.log("Inside getUserAnsweredFreeText");
    await this.quest
      .get_user_answered_free_text_answers(
        this.userId,
        this.schedule_id,
        this.Section_Id
      )
      .subscribe(async data => {
        console.log("user answer essay data", data);
        this.user_essay_answers = await data.essayans;
        console.log("user ans len", this.user_essay_answers);
        await this.populateQuestions();
        await this.setDefaultCount();
      });
  }

  async ngAfterViewInit() {
    await this.setupDevices();
  }
  async setupDevices() {
    // console.log("insid setupdevices")
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true
        });
        if (stream) {
         
          this.localstream = stream.getTracks();
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
          this.error = null;
          
        } else {
          this.error = "You have no output video device";
        }
      } catch (e) {
        
        this.error = e;
      }
    }
  }

  capture() {
    this.drawImageToCanvas(this.video.nativeElement);
    
    if (this.captures.length >= 1) {
      this.captures.pop();
    }
    this.captures.push(this.canvas.nativeElement.toDataURL("image/png"));
   
    this.isCaptured = true;
    const userid = sessionStorage.getItem("id");
    const user = {
      userId: userid,
      imageURL: this.captures[0]
    };
     this.userDetails.updateSectionImages(user).subscribe(data => {
      // console.log("data",data)
      this.video.nativeElement.pause();
      this.video.nativeElement.src = "";
      this.localstream.stop();
    });
  }

  drawImageToCanvas(image: any) {
    
    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(image, 0, 0, this.WIDTH, this.HEIGHT);
  }

  getCategory(id) {
  
    this.answer_text = this.answer.filter(p => p.Question_Id == id);
    return this.answer.filter(p => p.Question_Id == id);
  }

  async populateQuestions() {
    this.displayQuestionsArray = await this.populateDisplayQues();
    console.log("Inside populateQuestions", this.displayQuestionsArray);
    let index = 0;
    for (const row of this.displayQuestionsArray) {
      if (this.isArray(row)) {
        console.log("Inside array compre");
        for (const item of row) {
          await this.populateItem(item, index, "array");
        }
      } else {
        await this.populateItem(row, index, "");
      }

      index++;
      if (index >= this.displayQuestionsArray.length) {
        console.log("index index equal length of row");
        this.countOfCallingDefaultCounter =
          this.countOfCallingDefaultCounter + 1;
      }
    }
  
  }

  async populateItem(item, index, itemType) {
    console.log(
      "in populate item",
      "index of incoming display question array element",
      index
    );

    if (index == 0) {
      this.zeroIndexCounter = this.zeroIndexCounter + 1;

      if (this.zeroIndexCounter === 1) {
        console.log("inside index is 0", this.visit);
        this.visited[0] = true;
        this.visitedArray = 0;
        this.visitedArrays.push(this.visitedArray);
        this.visit = this.visit + 1; //put this in ngonit if this function failed to execute but you want correct visited count

        this.getcolor(item, index);
      }
    }
    const mcqTypes = [
      "Multiple Choice",
      "MCQ With Free Text",
      "Comprehension With MCQ"
    ];

    const freeTextTypes = [
      "Free Text",
      "Comprehension With Free Text",
      "None",
      "Algorithm"
    ];

    if (mcqTypes.includes(item.type_name)) {
      const userAnswer = await this.user_answers.find(
        answer => answer.Question_id === item.Id
      );
      if (userAnswer) {
        console.log("userAnswer", userAnswer);
        this.type_ques_id = `q${item.Id}`;
        item.selected = userAnswer.Chosen_Answer_Id;
        console.log("check if selected value is populated", item);
        this.save_answer.set(this.type_ques_id, [
          1,
          userAnswer.Explanation,
          userAnswer.Chosen_Answer_Id,
          item.Id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);

        this.fill[item.Id] = userAnswer.Chosen_Answer_Id;
        if (itemType == "array") {
          this.visitedComprehensionTab[item.Id] = true;
        }
        this.prevSelectedAnswerArray[this.type_ques_id] =
          userAnswer.Chosen_Answer_Id;
        if (
          (userAnswer.Chosen_Answer_Id !== null && userAnswer.Chosen_Answer_Id !== undefined) &&
          index > 0 &&
          !(item.type_name === "MCQ With Free Text")
        ) {
          console.log("inside user selected answer");
          this.visited[index] = true;
          this.visitedArray = index;
          this.visitedArrays.push(this.visitedArray);
        }

        if (item.type_name == "MCQ With Free Text") {
          this.showTextArea[item.Id] = false;
          item.textValue = userAnswer.Explanation;
          if ((userAnswer.Explanation !== null && userAnswer.Explanation !== undefined) && index > 0) {
            this.visited[index] = true;
            this.visitedArray = index;
            this.visitedArrays.push(this.visitedArray);
          }
        }
        console.log(
          "inside this.displayQuestionsArray after updating selected",
          this.displayQuestionsArray
        );
      }
      console.log("userAnswer", userAnswer);
      console.log("visited questions", this.visited);
    }

    if (freeTextTypes.includes(item.type_name)) {
      const userAnswer = await this.user_essay_answers.find(
        answer => answer.Question_id === item.Id
      );
      console.log("compre free text question-id", userAnswer);
      if (userAnswer) {
        console.log(`userEssAnswer:${item.Id} :::::${userAnswer}`);

        item.textValue = userAnswer.Essay_Answer;
        console.log(`userEssAnswer:${item.Id} :::::${item.textValue}`);
        this.essay_id = `q${item.Id}`;
        this.essay_str.set(this.essay_id, [
          item.textValue,
          item.Id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);
        this.save_essay = this.essay_str;
        // this.fill[this.essay_id] = item.textValue;
        this.prevSelectedAnswerArray[this.type_ques_id] = item.textValue;
        if (
          (userAnswer.Essay_Answer !== null &&
            userAnswer.Essay_Answer !== undefined) &&
          index > 0
        ) {
          this.roughspace_flag[item.Id] = true;
          this.visited[index] = true;
          this.visitedArray = index;
          this.visitedArrays.push(this.visitedArray);
        }
        console.log(
          "inside this.displayQuestionsArray after updating selected",
          this.displayQuestionsArray
        );
      }
      console.log("userAnswer", userAnswer);
      console.log("item.selected", item.selected);
    }
  }

  @HostListener("window:blur", ["$event"])
  onBlur(event: any): void {
    this.popupcounter = this.popupcounter + 1;

    if (this.popupcounter <= 2) {
      this.modalRef = this.modal.open(this.modalStart);
      setTimeout(() => {
        this.modalRef.close(this.modalStart);
      }, 3000);
    }
  }

  update() {
    MathJax.Hub.Config({
      showMathMenu: false,
      // jax: ["input/TeX", "output/HTML-CSS"],
      tex2jax: {
        inlineMath: [
          ["$", "$"],
          ["\\(", "\\)"]
        ]
        //processEscapes: true,
        // skipTags: ['script', 'noscript', 'style', 'textarea', 'pre', 'code']
      },
      menuSettings: { zoom: "Double-Click", zscale: "20%" },
      CommonHTML: { linebreaks: { automatic: true } },
      "HTML-CSS": {
        scale: 100,
        linebreaks: { automatic: true, width: "container" }
      },
      SVG: { linebreaks: { automatic: true } }
    });
    setTimeout(() => {
      MathJax.Hub.Queue([
        "Typeset",
        MathJax.Hub,
        document.getElementsByClassName("answers")
      ]);
    }, 1000);
  }
  //check textarea for roughspace indicator
  textAreaEmpty(row, i) {
    if (row.textValue != "") {
      // j=i
      //
      this.roughspace_filter[row.Id] = true;
    }
  }

  essayAreaEmpty(row, i) {
    console.log("inside essayAreaEmpty", row, this.esarr[row.Id]);
    console.log(
      "Printing textvalue initial",
      this.prevSelectedAnswerArray.get(this.essay_id)
    );

    if (this.isArray(row)) {
      console.log("is array", row);
      this.essay_id = `q${row[0].Id}`;
    } else {
      console.log("is not array", row.Id);
      this.essay_id = `q${row.Id}`;
    }

    console.log("this.essay_id*************", this.essay_id);

    if (row.type_name == "MCQ With Free Text") {
      // this.save_answer[this.essay_id][1] = row.textValue
      const essay_id = this.save_answer.get(this.essay_id);
      essay_id[1] = row.textValue;
      console.log("row text value ****", row.textValue, essay_id[1]);
    } else {
      console.log("inside else no mcq with free text");
      this.arr = row;
      this.ques_index = i;

      if (this.esarr[row.Id] == null) {
        console.log(
          "inside this.esarr[row.Id] == null",
          "value",
          this.ques_index.textValue,
          this.esarr[row.Id]
        );

        if (this.ques_index.textValue != "") {
          console.log(
            "this.ques_index.textValue != '' not null",
            this.ques_index.textValue
          );
          let selectedComprehension = [];
          let asnweredComprehensionQns = 0;
          let isComprehensionConatainBoth: boolean = false;
          let answeredMCQCount: number = 0;
          let totalCount: number = 0;
          if (row.type_name == "Comprehension With Free Text") {
            console.log("inside Comp", this.comprehensionQuestionsArray);
            this.comprehensionQuestionsArray.map((data, index) => {
              data.map(selectedComp => {
                if (row.Id == selectedComp.Id) {
                  console.log(
                    "data********************************",
                    data,
                    selectedComp.type_name
                  );
                  selectedComprehension.push(data);
                  this.selectedFreeTextComprehensionIndex = index;
                }
              });
            });
            // console.log("selectedComprehension",selectedComprehension[0],selectedComprehension[0].length)

            for (var j = 0; j < selectedComprehension[0].length; j++) {
              console.log(
                "selectedComprehension[j].Id length",
                selectedComprehension[0][j].Id,
                selectedComprehension[0][j].textValue
              );
              if (
                selectedComprehension[0][j].type_name ===
                "Comprehension With MCQ"
              ) {
                console.log("setting comprehension contain both true");
                isComprehensionConatainBoth = true;
                if (selectedComprehension[0][j].selected) {
                  this.filter[row.Id] = true;
                  this.esarr[row.Id] = 1;
                  answeredMCQCount = answeredMCQCount + 1;
                }
              }
              // console.log("selectedComprehension[0][j].textValue != ''",selectedComprehension[0][j].textValue != '')
              if (
                selectedComprehension[0][j].textValue &&
                selectedComprehension[0][j].textValue.trim() != null
              ) {
                console.log(
                  "inisde count++",
                  selectedComprehension[0][j].textValue
                );
                this.filter[row.Id] = true;
                this.esarr[row.Id] = 1;
                asnweredComprehensionQns++;
              } else {
                console.log(
                  "inside else null",
                  selectedComprehension[0][j].Id,
                  selectedComprehension[0][j].textValue
                );
              }
            }
            console.log(
              "asnweredComprehensionQns",
              asnweredComprehensionQns,
              selectedComprehension[0].length
            );
            if (!isComprehensionConatainBoth) {
              if (asnweredComprehensionQns == selectedComprehension[0].length) {
                console.log(
                  "length inside",
                  this.selectedFreeTextComprehensionIndex
                );

                // this.unanswered = this.unanswered - 1;
                // this.answered = this.answered + 1;

                this.comprehensionUnanswered = this.comprehensionUnanswered - 1;
                // this.unanswered = this.MCQUnanswered + this.comprehensionUnanswered
                this.unanswered = this.unanswered - 1;
                this.answered = this.answered + 1;

                this.answeredAllComprehensionQnsFreeText[
                  this.selectedFreeTextComprehensionIndex
                ] = true;
              }
            }
            if (isComprehensionConatainBoth) {
              console.log("inside ft iscomprehension contain all true");
              totalCount = asnweredComprehensionQns + answeredMCQCount;
              this.totalCount = totalCount;
              console.log("totalcount", totalCount);
              this.mcqCount = answeredMCQCount;
              this.ftCount = asnweredComprehensionQns;
              if (totalCount == selectedComprehension[0].length) {
                this.comprehensionUnanswered = this.comprehensionUnanswered - 1;
                // this.unanswered = this.MCQUnanswered + this.comprehensionUnanswered
                this.unanswered = this.unanswered - 1;
                this.answered = this.answered + 1;

                this.answerAllComprehension[
                  this.selectedFreeTextComprehensionIndex
                ] = true;
              }
            }
          } else {
            this.MCQUnanswered = this.MCQUnanswered - 1;
            this.unanswered = this.unanswered - 1;
            this.answered = this.answered + 1;
            this.esarr[row.Id] = 1;
            this.filter[row.Id] = true;
          }
        }
      }

      if (row.textValue != "") {
        console.log("row.textValue is not null");
        this.roughspace_flag[row.Id] = true;
        this.answerType = "Free Text";
        if (Array.isArray(this.arr)) {
          console.log("inside array essay areaempty", row, row[0].Id);

          this.essay_id = `q${row[0].Id}`;
          this.essay_str.set(this.essay_id, [
            row[0].textValue,
            row[0].Id,
            this.userId,
            this.schedule_id,
            this.email,
            null
          ]);
          this.save_essay = this.essay_str;
          // this.essay_str[this.essay_id] = [row.textValue, row.Id];
        } else {
          console.log("inside not array essay areaempty", row, row.Id);

          this.essay_id = `q${row.Id}`;
          // this.essay_str[this.essay_id] = [row.textValue, row.Id];
          this.essay_str.set(this.essay_id, [
            row.textValue,
            row.Id,
            this.userId,
            this.schedule_id,
            this.email,
            null
          ]);
          this.save_essay = this.essay_str;
          // this.prevSelectedAnswerArray.set(this.essay_id,[row.textValue])
        }
      } else {
        console.log("row.textValue is null");
        console.log(
          "inside clearing",
          this.answeredAllComprehensionQnsFreeText[
            this.selectedFreeTextComprehensionIndex
          ]
        );
        let selectedComprehension = [];
        // let selectedComprehensionIndex = 0

        if (row.type_name == "Comprehension With Free Text") {
          this.comprehensionQuestionsArray.map((data, index) => {
            data.map(selectedComp => {
              if (row.Id == selectedComp.Id) {
                console.log("data********************************", data);
                selectedComprehension.push(data);
                this.selectedFreeTextComprehensionIndex = index;
              }
            });
          });
          if (!this.isComprehensionContainBoth) {
            if (
              this.answeredAllComprehensionQnsFreeText[
                this.selectedFreeTextComprehensionIndex
              ] == true
            ) {
              this.answeredAllComprehensionQnsFreeText[
                this.selectedFreeTextComprehensionIndex
              ] = false;
              console.log(
                "****",
                this.answeredAllComprehensionQnsFreeText[
                  this.selectedFreeTextComprehensionIndex
                ]
              );
              // this.unanswered = this.unanswered + 1;
              //   this.answered = this.answered - 1;
              this.comprehensionUnanswered = this.comprehensionUnanswered + 1;
              // this.unanswered = this.MCQUnanswered - this.comprehensionUnanswered
              this.unanswered = this.unanswered + 1;
              this.answered = this.answered - 1;
              this.esarr[row.Id] = null;
              this.filter[row.Id] = false;
              this.roughspace_flag[row.Id] = false;
              this.essay_str.set(this.essay_id, [
                null,
                row.Id,
                this.userId,
                this.schedule_id,
                this.email,
                null
              ]);
            }
          }
          if (this.isComprehensionContainBoth) {
            if (
              this.answerAllComprehension[
                this.selectedFreeTextComprehensionIndex
              ] == true
            ) {
              this.comprehensionUnanswered = this.comprehensionUnanswered + 1;
              // this.unanswered = this.MCQUnanswered - this.comprehensionUnanswered
              this.unanswered = this.unanswered + 1;
              this.answered = this.answered - 1;
              this.esarr[row.Id] = null;
              this.filter[row.Id] = false;
              this.roughspace_flag[row.Id] = false;
              this.essay_str.set(this.essay_id, [
                null,
                row.Id,
                this.userId,
                this.schedule_id,
                this.email,
                null
              ]);
              this.answerAllComprehension[
                this.selectedFreeTextComprehensionIndex
              ] = false;
            }
          } else {
            this.esarr[row.Id] = null;
            this.filter[row.Id] = false;
            this.roughspace_flag[row.Id] = false;
            this.essay_str.set(this.essay_id, [
              null,
              row.Id,
              this.userId,
              this.schedule_id,
              this.email,
              null
            ]);
          }
        } else {
          this.roughspace_flag[row.Id] = false;
          // this.essay_str[this.essay_id] = [null, row.Id];
          this.essay_str.set(this.essay_id, [
            null,
            row.Id,
            this.userId,
            this.schedule_id,
            this.email,
            null
          ]);
          if (this.esarr[row.Id] != null) {
            console.log(
              "inside this.esarr[row.Id] == null",
              this.esarr[row.Id]
            );
            this.unanswered = this.unanswered + 1;
            this.MCQUnanswered = this.MCQUnanswered + 1;
            this.answered = this.answered - 1;
            this.esarr[row.Id] = null;
            this.filter[row.Id] = false;
          }
        }
      }
    }
    console.log("at end save essay_id", this.essay_id);
    console.log(
      "Printing textvalue after",
      this.prevSelectedAnswerArray.get(this.essay_id)
    );
  }

  //save essay_answer
  async save_essayanswer(showSwalAlert) {
    this.isLoading = true;
    
    clearInterval(this.countDown);
    console.log("after clear inside essay", this.countDown);
    // console.log("inside save essay")
    this.end_time();
    // clearInterval(this.intervalId);
    if (this.sectioncount === null) {
      this.sectioncount = 0;
    }
    this.sectioncount++;
    localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));
    // alert(this.sectioncount)
    this.category_start_time = sessionStorage.getItem("Start_Time");
    this.category_time.end_time = this.end_button;
    this.category_time.start_time = this.category_start_time;
    this.category_time.category_id = this.questions[0].Section_Id;
    this.category_time.user_id = sessionStorage.getItem("id");

    this.section_time.end_time = this.end_button;
    this.section_time.start_time = sessionStorage.getItem("Start_Time");
    this.section_time.section_name = localStorage.getItem("Section_Name");
    this.section_time.user_id = sessionStorage.getItem("id");
    this.section_time.email = sessionStorage.getItem("email");
    this.section_time.category_id = this.questions[0].Section_Id;
    clearTimeout(this.myTime);
    this.myTime = null;
    clearTimeout(this.timings);
    this.timings = null;
    localStorage["targetSection" + this.questions[0].Section_Id] = 0;
    var tempp = localStorage.getItem(
      "targetSection" + this.questions[0].Section_Id
    );
    localStorage.setItem(
      `${this.category_time.user_id}[${this.questions[0].Section_Id}]`,
      "completed"
    );
    localStorage["section_button" + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem(
      "section_button" + this.questions[0].Section_Id
    );
    console.log(
      "this.quest.submit_essay this.essay_str",
      this.essay_str,
      this.save_essay
    );
    this.save_essay = this.essay_str;
    this.save_essay.forEach((array, key) => {
      console.log("array inside foreach", array);
      array.splice(-1, 1);
    });
    this.quest.submit_essay(this.save_essay).subscribe(
      async data => {
        
        if (data.code === 200) {
          
          if (showSwalAlert == true) {
            this.isLoading = false;
            Swal.fire({
              title: "Success",
              text: "Answers Saved Successfully!",
              icon: "success",
              showCancelButton: false,
              confirmButtonText: "OK"
            }).then(result => {
              if (result.isConfirmed) {
              }
            });
          }
        } else if (data.code === 400) {
        
          if (showSwalAlert == true) {
            this.isLoading = false;
            Swal.fire({
              title: "Alert",
              text: data.failed,
              icon: "warning",
              showCancelButton: false,
              confirmButtonText: "OK"
            }).then(result => {
              if (result.isConfirmed) {
                // this.router.navigateByUrl('/test_scheduler');
              }
            });
          }
        }
      
      },
      err => {
        //console.error(err);
      }
    );
    this.exitFullScreen();
    this.send_time();
    this.sectiontime();
    this.router.navigateByUrl("section");
  }

  //save essay_answer
  async save_essayanswer_count() {
    this.end_time();
    // clearInterval(this.intervalId);
    if (this.sectioncount === null) {
      this.sectioncount = 0;
    }
    this.sectioncount++;
    localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));
    // alert(this.sectioncount)
    this.category_start_time = sessionStorage.getItem("Start_Time");
    this.category_time.end_time = this.end_button;
    this.category_time.start_time = this.category_start_time;
    this.category_time.category_id = this.questions[0].Section_Id;
    this.category_time.user_id = sessionStorage.getItem("id");

    this.section_time.end_time = this.end_button;
    this.section_time.start_time = sessionStorage.getItem("Start_Time");
    this.section_time.section_name = localStorage.getItem("Section_Name");
    this.section_time.user_id = sessionStorage.getItem("id");
    this.section_time.email = sessionStorage.getItem("email");
    this.section_time.category_id = this.questions[0].Section_Id;

    clearTimeout(this.myTime);
    clearTimeout(this.time_to_capture);
    clearTimeout(this.timings);
    this.myTime = null;
    this.time_to_capture = null;
    this.timings = null;
    this.counter = null;
    this.countDown = null;
    this.time = null;
    this.timer_alert = null;
    localStorage["targetSection" + this.questions[0].Section_Id] = 0;
    var tempp = localStorage.getItem(
      "targetSection" + this.questions[0].Section_Id
    );
    localStorage.setItem(
      `${this.category_time.user_id}[${this.questions[0].Section_Id}]`,
      "completed"
    );
    localStorage["section_button" + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem(
      "section_button" + this.questions[0].Section_Id
    );
    this.save_essay = this.essay_str;
    this.save_essay.forEach((array, key) => {
      array.splice(-1, 1);
    });

    this.quest.submit_essay(this.save_essay).subscribe(
      async data => {},

      err => {
        //console.error(err);
      }
    );
    this.exitFullScreen();
    this.send_time();
    this.sectiontime();
    this.router.navigateByUrl("section");
  }

  //get co-ordinates in essay-textarea
  getCaretPos(oField) {
    if (oField.selectionStart || oField.selectionStart == "0") {
      this.caretPos = oField.selectionStart;
    }
  }

  //Word Counter function
  wordCounter(row, i) {
    console.log("inside word counter****************");
    this.wordCount = row.textValue ? row.textValue.split(/\s+/) : 0;
    console.log(this.wordCount, "word count array");

    this.words[row.Id] = this.wordCount ? this.wordCount.length : 0;
    this.roughspace_flag[row.Id] = true;
    this.wordc = this.wordCount.length;
    console.log(this.wordc, "word count");
  }

  action(event) {
    //alert("Inside event")

    if (this.wordc >= 300) {
      if (this.lastPos == 0) {
        this.lastPos = this.caretPos;
      }

      this.delkeypress = false;
      if (
        event.keyCode >= 48 &&
        event.keyCode <= 90 &&
        (this.lastPos == this.caretPos || this.lastPos < this.caretPos)
      ) {
        event.stopPropagation();
        return false;
      }
      if (this.caretPos < this.lastPos) {
        this.delkeypress = true;
        if (event.keyCode >= 48 && event.keyCode <= 90) {
          event.startPropagation();
        }
      }
    }
  }

  //open roughwork space
  openroughspace() {
    if (this.myvar == true) {
      //this.myvar = false;
    } else {
      this.myvar = true;
    }
  }

  faFilter = faFilter;
  faPauseCircle = faPauseCircle;
  faHome = faHome;
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  faInfoCircle = faInfoCircle;
  faPencilAlt = faPencilAlt;

  //Filter color

  getcolor(row, i) {
    //console.log("This fill in getcolor func",this.fill)
    let color = "red";
    if (i == 0 && this.fill[0] == null) {
      color = "#F9C118";
    }
    if (this.button_click == true && i != 0) {
      color = "red";
      this.button_click = false;
    }
    if (
      (this.visited[i] == true && this.fill[row.Id] == null) ||
      this.roughspace_flag[row.Id] == false
    ) {
      color = "#F9C118";
    }
    if (this.isArray(row)) {
      let count = 0;
      for (let subItem of row) {
        if (
          (this.fill[subItem.Id] != null && this.visited[i] == true) ||
          this.roughspace_flag[subItem.Id] == true
        ) {
          count++;
        }
        if (count === row.length) {
          color = "green";
        }
        if (this.book_mark[row[0].Id] == true) {
          console.log("row[0].Id", row[0].Id);
          color = "#7000a0";
        }
      }
    } else {
      if (
        (this.fill[row.Id] != null && this.visited[i] == true) ||
        this.roughspace_flag[row.Id] == true
      ) {
        color = "green";
      }
      if (this.book_mark[row.Id] == true) {
        color = "#7000a0";
      }
    }

    return color;
  }

  getComprehensionTabcolor(row, i) {
    // console.log("row in getComprehensionTabcolor",this.fill[row.Id] )

    let color = "red";
    if (i == 0 && this.fill[row.Id] == null) {
      color = "#F9C118";
    }
    if (this.comprehension_button_click == true && i != 0) {
      color = "red";
      this.comprehension_button_click = false;
    }
    if (
      (this.fill[row.Id] == null &&
        this.visitedComprehensionTab[row.Id] == true) ||
      this.roughspace_flag[row.Id]
    ) {
      color = "#F9C118";
    }
    if (
      (this.fill[row.Id] != null &&
        this.visitedComprehensionTab[row.Id] == true) ||
      this.roughspace_flag[row.Id]
    ) {
      color = "green";
    }
    if ((i == 0 && this.fill[row.Id] != null) || this.roughspace_flag[row.Id]) {
      color = "green";
    }
    return color;
  }

  //visited function
  visit_func(i) {
    this.visitedArray = i;

    //
    // this.essayAreaEmpty(questionIdarray, i);
    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }
    return;
  }

  //get category end time

  end_time() {
    console.log("inside end_time 2");
    // this.todaysDataTime = formatDate(this.today, 'hh:mm', 'en-US', '+0530');
    var now = moment().format("hh:mm:ss");

    this.date = new Date();

    console.log("now 3", now);

    this.end_button = now;
  }

  //disable browser backbutton
  @HostListener("window:popstate", ["$event"])
  onBrowserBackBtnClose(event: Event) {
    event.preventDefault();
    //window.history.forward();
    this.router.navigate(["/"], { replaceUrl: true });
  }
  @HostListener("document:keyup", ["$event"])
  keyup(event: KeyboardEvent) {
    // const modalRef = this.modal.open(this.modalKeyboard)
    // setTimeout(() => {
    //   modalRef.close(this.modalContent)
    // }, 3000);
    if (event.keyCode === 44) {
      const modalRef = this.modal.open(this.modalKeyboard);
      setTimeout(() => {
        modalRef.close(this.modalKeyboard);
      }, 3000);

      setTimeout(() => {
        modalRef.close(this.modalKeyboard);
      }, 3000);
      //e.preventDefault();
      // alert('keyup')
      //this.copyToClipboard()
      this.focuscount += 1;
      if (this.focuscount >= 6) {
        //alert('f>2')

        if (
          this.questions[0].type_name != "None" &&
          this.questions[0].type_name != "Algorithm"
        ) {
          this.submit_test();
        }
        if (
          this.questions[0].type_name == "None" ||
          this.questions[0].type_name == "Algorithm"
        ) {
          this.save_essayanswer(true);
        }
        //this.exitFullScreen();
        this.final();
        modalRef.close(this.modalKeyboard);
        this.router.navigateByUrl("final");
      }
    }
  }

  @HostListener("document:keydown", ["$event"])
  keydown(event: KeyboardEvent) {
    this.keypress = true;
    if (event.key === "Alt" || event.key === "Tab" || event.key === "Meta") {
      if (
        this.questions[0].type_name != "Algorithm"
        // || this.questions[0].type_name != 'MCQS_WITH_IMAGES'
      ) {
        this.focuscount += 1;
        const modalRef = this.modal.open(this.modalKeyboard);
        setTimeout(() => {
          modalRef.close(this.modalKeyboard);
        }, 3000);
        event.preventDefault();
        event.stopPropagation();
      } else {
        event.preventDefault();
        event.stopPropagation();
        this.code_Pos = this.caretPos;

        this.code_tabpress = this.code_tabpress + 1;
      }

      if (this.focuscount >= 6) {
        //alert('f>2')
        if (
          this.questions[0].type_name != "None" &&
          this.questions[0].type_name != "Algorithm"
        ) {
          this.submit_test();
        }
        if (
          this.questions[0].type_name == "None" ||
          this.questions[0].type_name == "Algorithm"
        ) {
          this.save_essayanswer(true);
        }
        this.final();
        //this.exitFullScreen();

        this.router.navigateByUrl("final");
      }
    }
    if (
      event.key === "F5" ||
      event.key === "F1" ||
      event.key === "F12" ||
      event.key === "Escape" ||
      event.key === "Control"
    ) {
      // if (this.questions[0].type_name != "Algorithm") {
      event.preventDefault();
      const modalRef = this.modal.open(this.modalKeyboard);
      setTimeout(() => {
        modalRef.close(this.modalKeyboard);
      }, 3000);
      // }
    }
  }

  //Disable keyboard combinations
  @HostListener("document:keydown.Control.Shift.j", ["$event"])
  @HostListener("document:keydown.Control.Shift.i", ["$event"])
  @HostListener("document:keydown.Control.Shift.p", ["$event"])
  @HostListener("document:keydown.Control.Shift.c", ["$event"])
  @HostListener("document:keydown.Control.Shift.m", ["$event"])
  @HostListener("document:keydown.Control.Shift.d", ["$event"])
  @HostListener("document:keydown.Control.o", ["$event"])
  @HostListener("document:keydown.Control.p", ["$event"])
  @HostListener("document:keydown.Control.Tab", ["$event"])
  @HostListener("document:keydown.Shift.Tab", ["$event"])
  @HostListener("document:keydown.Alt.Tab", ["$event"])
  @HostListener("document:keydown.Control.c", ["$event"])
  Keydown(e: KeyboardEvent) {
    this.keypress = true;

    this.focuscount += 1;
    e.preventDefault();
    e.stopPropagation();

    if (this.focuscount >= 6) {
      if (
        this.questions[0].type_name != "None" ||
        this.questions[0].type_name != "Algorithm"
      ) {
        this.submit_test();
      }
      if (
        this.questions[0].type_name == "None" ||
        this.questions[0].type_name == "Algorithm"
      ) {
        this.save_essayanswer(true);
      }
      this.final();

      this.router.navigateByUrl("final");
    }
  }
  copyToClipboard() {
    var aux = document.createElement("input");
    aux.setAttribute("value", "print screen disabled!");
    document.body.appendChild(aux);
    aux.select();
    document.execCommand("copy");
    // Remove it from the body
    document.body.removeChild(aux);
    alert("Print screen disabled!");
  }

  onselect(row, i) {
    console.log("row************ inside onselect", row);
    this.prevQuestionId = this.selectedQuestionId;
    if (this.isArray(row)) {
      console.log("selected row is array", row[0].Id);
      this.selectedQuestionId = `q${row[0].Id}`;
    } else {
      console.log("selected row is not array", row.Id);
      this.selectedQuestionId = `q${row.Id}`;
    }
    console.log(
      " this.prevQuestionId ",
      this.prevQuestionId,
      this.selectedQuestionId
    );
    // Flush previous question's textarea state only when necessary:
    // - previous question has a non-empty `textValue` (user typed), OR
    // - the currently focused element is a textarea/input (user was editing)
    if (this.prevQuestionId) {
      try {
        const prevIdNum = parseInt(this.prevQuestionId.replace(/^q/, ""), 10);
        const prevRow = this.displayQuestionsArray.find(el => {
          if (Array.isArray(el)) return el[0] && el[0].Id === prevIdNum;
          return el && el.Id === prevIdNum;
        });
        if (prevRow) {
          const prevText = Array.isArray(prevRow) ? prevRow[0].textValue : prevRow.textValue;
          const activeEl = (document && document.activeElement) as HTMLElement | null;
          const activeIsText = !!(
            activeEl && (activeEl.tagName === "TEXTAREA" || activeEl.tagName === "INPUT")
          );
          if ((prevText && String(prevText).trim() !== "") || activeIsText) {
            this.essayAreaEmpty(prevRow, /* i param not required for update */ 0);
          }
        }
      } catch (e) {
        console.warn("failed to flush previous textarea state", e);
      }
    }
    this.previousValue = row;
    this.selectedIndex = i;
    this.previousSelectedTabIndex.push(i);
    this.visitedArray = i;
    this.tab_counter = this.tab_counter + 1;

    this.visited[i] = true;
    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }

    this.submit = this.save_answer;

    for (const [key, value] of this.submit.entries()) {
      this.fill[value[3]] = value[2];
    }

    console.log("this.fil*************", this.fill);
    console.log("callIndividualSave inside onselect", this.essay_id);

    this.callIndividualSave();

    if (this.isArray(row)) {
      console.log("inisde array", this.activeSubTab, row);
      // if(row[0].selected)
      // this.comprehensionTabColor[row[0].Id] = "#F9C118"
      this.visitedComprehensionTab[row[0].Id] = true;
      console.log(
        "this.*visitedComprehensionTab inside onselect",
        this.visitedComprehensionTab[row[0].Id]
      );
      this.activeSubTab = 0;
      this.getCategory(row[0].Id);
      //route
      this.router.navigate(["test", row[0].Id]);
    } else {
      this.getCategory(row.Id);
      this.router.navigate(["test", row.Id]);
    }
  }

  selectedAnswer: string;
  check;

  checkState(el, questions, button) {
    this.answerType = "MCQ";
    console.log(
      "inside checkstate checked,row,el",
      el.checked,
      questions,
      el,
      this.unanswered
    );

    // alert(el.value)
    this.showTextArea[questions.Id] = el.checked;
    this.season_question = questions.Question_Id;
    // this.comprehensionTabColor[questions.Id] = 'green'
    console.log(
      "inside checkstate checking currentchecked and prevselected",
      this.currentCheckedValue,
      this.prevSelectedAnswerArray.get(questions.Question_Id)
    );
    // this.prevSelectedAnswerArray.set(`q${questions.Question_Id}`,[this.currentCheckedValue])
    console.log(
      "Printing this.currentCheckedValue",
      this.currentCheckedValue,
      this.prevSelectedAnswerArray.get(questions.Question_Id)
    );

    setTimeout(() => {
      console.log(
        "currentCheckedValue and el.check",
        this.currentCheckedValue,
        el.value
      );
      console.log(
        "this.filter[questions.Question_Id]",
        this.filter[questions.Question_Id]
      );
      console.log(
        "this.fill[questions.Question_Id]",
        this.fill[questions.Question_Id]
      );

      if (this.fill[questions.Question_Id] === el.value) {
        console.log("inside if");

        el.checked = false;
        this.check = el.checked;

        this.ren.removeClass(el["_elementRef"].nativeElement, "cdk-focused");
        this.ren.removeClass(
          el["_elementRef"].nativeElement,
          "cdk-program-focused"
        );

        this.currentCheckedValue = null;
        this.selectedAnswer = null;
      } else {
        console.log(
          "inside else and el.check",
          this.currentCheckedValue,
          el.value
        );

        this.currentCheckedValue = el.value;
        //to consider selected question during counting
        this.fill[questions.Question_Id] = this.currentCheckedValue;
      }

      this.filter_answer_id = questions.Question_Id;

      this.filter[this.filter_answer_id] = el.checked;

      for (let i in this.filter) this.radio_ques_id = questions.Question_Id;

      this.filter_answer_id = questions.Question_Id;

      this.radio_ans_id = el.value;

      this.type_ques_id = `q${this.radio_ques_id}`;
      console.log("this.type_ques_id ", this.type_ques_id, this.radio_ans_id);
      if (
        this.filter[this.filter_answer_id] == true &&
        this.roughspace_filter[questions.Question_Id] == true
      ) {
        console.log("inside roughspace true and answer true");
        this.save_answer.set(this.type_ques_id, [
          1,
          null,
          this.radio_ans_id,
          this.radio_ques_id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);
      } else if (
        this.roughspace_filter[questions.Question_Id] == true &&
        this.filter[this.filter_answer_id] == false
      ) {
        this.save_answer;
        console.log("inside roughspace true and answer false");
        this.save_answer.set(this.type_ques_id, [
          1,
          null,
          null,
          this.radio_ques_id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);
      } else if (
        this.roughspace_filter[questions.Question_Id] == null &&
        this.filter[this.filter_answer_id] == true
      ) {
        console.log(
          "inside roughspace false and answer true",
          this.radio_ans_id
        );
        this.save_answer.set(this.type_ques_id, [
          null,
          null,
          this.radio_ans_id,
          this.radio_ques_id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);
        console.log("get********", this.save_answer.get(this.type_ques_id));
      } else {
        console.log("inside roughspace false and answer false");

        var a = this.type_ques_id;
        this.save_answer.set(this.type_ques_id, [
          null,
          null,
          null,
          this.radio_ques_id,
          this.userId,
          this.schedule_id,
          this.email,
          null
        ]);
      }

      this.submit = this.save_answer;

      console.log("unasnwered inside cjheck", this.unanswered);
      console.log("this.questionIdarray bfre****", this.questionIdarray);
      console.log("this.filter****", this.filter);

      console.log("this.save_answer*******", Array.from(this.save_answer));

      for (const [key, value] of this.submit.entries()) {
        this.fill[value[3]] = value[2];
      }

      console.log("this.fill inside checkstate", this.fill);
      let selectedComprehension = [];
      let asnweredComprehensionQns = 0;
      let selectedComprehensionIndex = 0;
      if (
        questions.type_name == "Comprehension With MCQ" ||
        questions.type_name == "Comprehension With Free Text"
      ) {
        console.log("inside Comp", this.comprehensionQuestionsArray);
        let isComprehensionConatainBoth: boolean = false;
        let ftComprehensionCount: number = 0;
        let answeredftComprehensionCount: number = 0;
        let totalCount: number = 0;
        this.comprehensionQuestionsArray.map((data, index) => {
          data.map(selectedComp => {
            if (questions.Id == selectedComp.Id) {
              console.log(
                "data********************************",
                data,
                selectedComp.type_name,
                "*********************"
              );
              selectedComprehension.push(data);
              selectedComprehensionIndex = index;
            }
          });
        });

        for (var j = 0; j < selectedComprehension[0].length; j++) {
          if (
            selectedComprehension[0][j].type_name ===
            "Comprehension With Free Text"
          ) {
            ftComprehensionCount = ftComprehensionCount + 1;
            isComprehensionConatainBoth = true;
            console.log("is comprehension contain both", true);
            if (selectedComprehension[0][j].textValue) {
              answeredftComprehensionCount = answeredftComprehensionCount + 1;
            }
          }
          console.log(
            "selectedComprehension[j].Id",
            selectedComprehension[0][j].Id
          );
          console.log(
            "this.fill[selectedComprehension[j].Id]",
            this.fill[selectedComprehension[0][j].Id]
          );
          if (this.fill[selectedComprehension[0][j].Id] != null) {
            console.log("inisde count++");
            asnweredComprehensionQns++;
          }
        }
        console.log(
          "asnweredComprehensionQns",
          asnweredComprehensionQns,
          selectedComprehension[0].length
        );
        if (isComprehensionConatainBoth == false) {
          if (asnweredComprehensionQns == selectedComprehension[0].length) {
            console.log("length inside", selectedComprehensionIndex);
            console.log(
              this.comprehensionUnanswered,
              "comprehension unanswered ********"
            );
            console.log("MCQ UNANSWERD", this.MCQUnanswered);

            if (
              !(
                this.answeredAllComprehensionQns[selectedComprehensionIndex] ==
                true
              )
            ) {
              this.comprehensionUnanswered = this.comprehensionUnanswered - 1;
              this.unanswered =
                this.MCQUnanswered + this.comprehensionUnanswered;

              this.answeredAllComprehensionQns[
                selectedComprehensionIndex
              ] = true;
            }
          }
        }
        if (isComprehensionConatainBoth) {
          console.log(
            "comprehension contain both before manipulating tc",
            totalCount
          );
          totalCount = answeredftComprehensionCount + asnweredComprehensionQns;
          this.totalCount = totalCount;
          console.log(
            "comprehension contain both before manipulating(after updating) tc",
            totalCount,
            selectedComprehension[0].length
          );
          this.ftCount = answeredftComprehensionCount;
          this.mcqCount = asnweredComprehensionQns;
          this.isComprehensionContainBoth = isComprehensionConatainBoth;

          if (totalCount == selectedComprehension[0].length) {
            console.log("inside manipualating count");
            if (
              !(this.answerAllComprehension[selectedComprehensionIndex] == true)
            ) {
              console.log("further inside manipulating********");
              this.comprehensionUnanswered = this.comprehensionUnanswered - 1;
              this.unanswered =
                this.MCQUnanswered + this.comprehensionUnanswered;
              this.answerAllComprehension[selectedComprehensionIndex] = true;
            }
            console.log("error in manipulating********************");
          }
        }
      } else {
        console.log("this.filter***", this.filter);

        console.log(
          "questionIdarray inside else",
          this.questionIdarray,
          this.filter
        );

        this.MCQUnanswered =
          this.currentCategoryQuestionlength -
          this.comprehensionQuestionsArray.length;

        console.log("tempQuestionIdArray", this.tempQuestionIdArray);
        for (var key of this.tempQuestionIdArray.keys()) {
          console.log("key**", key);
          console.log(
            "this.questionIdarray.get(key)",
            this.tempQuestionIdArray.get(key)
          );

          if (this.filter[this.tempQuestionIdArray.get(key)] == true) {
            console.log("inisde**");
            this.MCQUnanswered = this.MCQUnanswered - 1;
          }
        }
        this.unanswered = this.MCQUnanswered + this.comprehensionUnanswered;
      }

      this.answered = this.total - this.unanswered;

      console.log("unanswered*********", this.unanswered);

      if (!this.isComprehensionContainBoth) {
        if (
          this.answeredAllComprehensionQns[selectedComprehensionIndex] ==
            true &&
          asnweredComprehensionQns == selectedComprehension[0].length - 1
        ) {
          console.log("inside all");
          this.comprehensionUnanswered = this.comprehensionUnanswered + 1;

          this.unanswered = this.unanswered + 1;
          this.answered = this.answered - 1;
          this.answeredAllComprehensionQns[selectedComprehensionIndex] = false;
        }
      }
      if (this.isComprehensionContainBoth) {
        if (
          this.answerAllComprehension[selectedComprehensionIndex] == true &&
          this.totalCount == selectedComprehension[0].length - 1
        ) {
          console.log("inside all when comp conatin both");
          this.comprehensionUnanswered = this.comprehensionUnanswered + 1;

          this.unanswered = this.unanswered + 1;
          this.answered = this.answered - 1;
          this.answerAllComprehension[selectedComprehensionIndex] = false;
        }
      }
    });
  }

  verifyIfUserEnteredRequiredDescription(questionIdarray, i) {
    let response = false;

    this.essay_id = `q${questionIdarray.get(
      `q${this.displayQuestionsArray[i].Id}`
    )}`;

    if (this.displayQuestionsArray[i].type_name == "MCQ With Free Text") {
      var essay_id = this.save_answer.get(this.essay_id);

      if (essay_id[2] != null) {
        if (essay_id[1] != null && essay_id[1] != "") {
          response = true;
        }
      } else {
        response = true;
      }
    } else {
      response = true;
    }

    return response;
  }

  verifyIfUserEnteredRequiredDescriptionOnTab() {
    let index;

    if (this.previousSelectedTabIndex.length > 1) {
      index = this.previousSelectedTabIndex[
        this.previousSelectedTabIndex.length - 1
      ];
    } else {
      index = 0;
    }

    let response = true;

    this.essay_id = `q${this.questionIdarray.get(
      `q${this.displayQuestionsArray[index].Id}`
    )}`;

    if (this.displayQuestionsArray[index].type_name == "MCQ With Free Text") {
      var essay_id = this.save_answer.get(this.essay_id);
      if (essay_id[2] != null) {
        if (essay_id[1] != null && essay_id[1] != "") {
          response = false;
        }
      } else {
        response = false;
      }
    } else {
      response = false;
    }

    return response;
  }

  //next button
  maxNumberOfTabs: number;
  selectedIndex: number = 0;

  nextStep(questionIdarray, i) {
    console.log("nextanswertypw", this.answerType);
    console.log("questionIdarray", questionIdarray);
    console.log("essarr inside next step", this.essay_str);

    this.selectedIndex = i;
    this.maxNumberOfTabs = this.currentCategoryQuestionlength;

    //this.visitedArray = i
    this.visitedArray = i + 1;
    this.questions.fin;

    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }

    this.visited[i + 1] = true;
    this.visited[i] = true;

    for (const [key, value] of this.submit.entries()) {
      this.fill[value[3]] = value[2];
    }

    if (this.selectedIndex != this.currentCategoryQuestionlength) {
      this.selectedIndex = this.selectedIndex + 1;
      this.previousSelectedTabIndex.push(this.selectedIndex);
    }
    // this.activeSubTab = 0;
    this.prevQuestionId = this.selectedQuestionId;
    if (this.isArray(this.displayQuestionsArray[this.selectedIndex])) {
      this.activeSubTab = 0;
      this.selectedQuestionId = `q${
        this.displayQuestionsArray[this.selectedIndex][0].Id
      }`;
      console.log("array inside next click", this.selectedQuestionId);
    } else {
      this.selectedQuestionId = `q${
        this.displayQuestionsArray[this.selectedIndex].Id
      }`;
      console.log("not array inside next click", this.selectedQuestionId);
    }

    console.log(
      "selectedQuestionId in next",
      this.selectedQuestionId,
      this.prevQuestionId
    );
    console.log("callIndividualSave inside nextstep", this.essay_id);

    this.callIndividualSave();
    console.log(
      "${this.displayQuestionsArray[this.selectedIndex]",
      this.displayQuestionsArray[this.selectedIndex]
    );
    console.log(
      "q${this.displayQuestionsArray[this.selectedIndex].Id}",
      `q${this.displayQuestionsArray[this.selectedIndex].Id}`
    );

    if (this.isArray(this.displayQuestionsArray[this.selectedIndex])) {
      console.log(
        "inside array next",
        this.displayQuestionsArray[this.selectedIndex][0].Id,
        questionIdarray
      );

      this.visitedComprehensionTab[
        this.displayQuestionsArray[this.selectedIndex][0].Id
      ] = true;
      console.log(
        "after visited comprehension in next",
        this.visitedComprehensionTab
      );
      this.activeSubTab = 0;
      this.getCategory(
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex][0].Id}`
        )
      );
      this.router.navigate([
        "test",
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex][0].Id}`
        )
      ]);
    } else {
      console.log("inside not array next");

      this.getCategory(
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex].Id}`
        )
      );
      this.router.navigate([
        "test",
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex].Id}`
        )
      ]);
    }

    // this.router.navigate(['test', questionIdarray[i]]);
  }

  async callIndividualSave() {
    this.prevSelectedAnswer = this.prevSelectedAnswerArray.get(
      this.prevQuestionId
    );
    console.log(
      "prevSelectedAnswer",
      this.prevSelectedAnswer,
      this.prevQuestionId
    );
    if (this.answerType == "Free Text") {
      this.save_individual_ans_array = this.essay_str.get(this.prevQuestionId);
      // console.log("save_individual_ans_array",this.save_individual_ans_array[0],this.prevSelectedAnswer[0])
      if (
        this.save_individual_ans_array &&
        this.prevSelectedAnswer &&
        this.save_individual_ans_array[0] != "" &&
        this.prevSelectedAnswer[0] != this.save_individual_ans_array[0]
      )
        this.save__individual_essayanswer(this.prevQuestionId);
    } else {
      this.save_individual_ans_array = this.save_answer.get(
        this.prevQuestionId
      );
      console.log("save_individual_ans_array", this.save_individual_ans_array);
      if (
        this.save_individual_ans_array &&
        this.prevSelectedAnswer &&
        this.save_individual_ans_array[2] != null &&
        this.prevSelectedAnswer[0] != this.save_individual_ans_array[2]
      )
        this.save_individual_mcqs(this.prevQuestionId);
    }
  }

  async checkFalseResponsesMCQ(answerArray) {
    this.falseResponseIdsMCQ = [];
    answerArray.forEach((array, key) => {
      if (array[7] == false) {
        this.falseResponseIdsMCQ.push(key);
      }
    });
  }

  async checkFalseResponsesFreeText(answerArray) {
    this.falseResponseIdsFreeText = [];
    answerArray.forEach((array, key) => {
      if (array[5] == false) {
        this.falseResponseIdsFreeText.push(key);
      }
    });
  }

  async save__individual_essayanswer(questionId) {
    await this.checkFalseResponsesFreeText(this.essay_str);

    this.save_individual_ans_array = this.essay_str.get(questionId);
    this.save_individual_ans_array.splice(-1, 1);
    await this.prepareCombinedIndividualAnsArrayFreeText();

    this.quest
      .save_individual_essayanswer(
        this.combinedIndividualAnsArray,
        this.falseResponseIdsFreeText.length
      )
      .subscribe(
        async data => {
          if (data.code === 200) {
            console.log("data.code is 200");
            this.updateFlagForFreeText(questionId, true);
            console.log(
              "this.essay_str.get(questionId)[0]",
              this.essay_str.get(questionId)[0]
            );
            this.prevSelectedAnswerArray.set(questionId, [
              this.essay_str.get(questionId)[0]
            ]);
          } else if (data.code === 400) {
            console.log("data.code is 400");
            this.updateFlagForFreeText(questionId, false);
          } else {
            console.log("data.code is else");
            this.updateFlagForFreeText(questionId, false);
          }
        },
        err => {
          console.log("data.code is 504");
          this.updateFlagForFreeText(questionId, false);
        }
      );
  }

  async prepareCombinedIndividualAnsArrayFreeText() {
    console.log(
      "this.save_individual_ans_array inside function",
      this.save_individual_ans_array
    );
    console.log(
      "falseResponseIdsFreeText",
      this.answerType,
      this.falseResponseIdsFreeText
    );
    this.combinedIndividualAnsArray = [];

    if (this.falseResponseIdsFreeText.length > 0) {
      for (let i = 0; i < this.falseResponseIdsFreeText.length; i++) {
        console.log("inside for");
        this.array = this.essay_str.get(this.falseResponseIdsFreeText[i]);
        this.combinedIndividualAnsArray.push([
          this.array[0],
          this.array[1],
          this.array[2],
          this.array[3],
          this.array[4]
        ]);
      }
      this.combinedIndividualAnsArray.push(this.save_individual_ans_array);
    } else {
      this.combinedIndividualAnsArray = this.save_individual_ans_array;
    }
    console.log("combinedIndividualAnsArray", this.combinedIndividualAnsArray);
  }

  async updateFlagForFreeText(questionId, flag: boolean) {
    console.log("flag inside updateFlagForFreeText", flag);
    this.essay_str.get(questionId)[5] = flag;
    for (let i = 0; i < this.falseResponseIdsFreeText.length; i++) {
      if (flag == true) {
        this.prevSelectedAnswerArray.set(this.falseResponseIdsFreeText[i], [
          this.essay_str.get(this.falseResponseIdsFreeText[i])[0]
        ]);
      }
      this.essay_str.get(this.falseResponseIdsFreeText[i])[5] = flag;
    }
    this.save_individual_ans_array = [];
  }

  async save_individual_mcqs(questionId) {
    console.log("Inside save individual MCQ", this.save_answer, questionId);
    await this.checkFalseResponsesMCQ(this.save_answer);
    this.save_individual_ans_array = this.save_answer.get(questionId);
    this.save_individual_ans_array.splice(-1, 1);
    await this.prepareCombinedIndividualAnsArrayMCQ();
    await this.quest
      .save_individual_mcq(
        this.combinedIndividualAnsArray,
        this.falseResponseIdsMCQ.length
      )
      .subscribe(
        async data => {
          if (data.code === 200) {
            console.log("data.code is 200");
            this.updateFlagForMCQ(questionId, true);
            this.prevSelectedAnswerArray.set(questionId, [
              this.save_answer.get(questionId)[2]
            ]);
          } else if (data.code === 400) {
            console.log("data.code is 400");
            this.updateFlagForMCQ(questionId, false);
          } else {
            console.log("data.code is else");
            this.updateFlagForMCQ(questionId, false);
          }
        },
        err => {
          console.log("data.code is 504");
          this.updateFlagForMCQ(questionId, false);
        }
      );
  }

  async prepareCombinedIndividualAnsArrayMCQ() {
    console.log(
      "this.save_individual_ans_array inside function",
      this.save_individual_ans_array
    );
    console.log("answerType", this.answerType);
    this.combinedIndividualAnsArray = [];

    if (this.falseResponseIdsMCQ.length > 0) {
      for (let i = 0; i < this.falseResponseIdsMCQ.length; i++) {
        this.array = this.save_answer.get(this.falseResponseIdsMCQ[i]);
        this.combinedIndividualAnsArray.push([
          this.array[0],
          this.array[1],
          this.array[2],
          this.array[3],
          this.array[4],
          this.array[5],
          this.array[6]
        ]);
      }

      this.combinedIndividualAnsArray.push(this.save_individual_ans_array);
    } else {
      this.combinedIndividualAnsArray = this.save_individual_ans_array;
    }
    console.log("combinedIndividualAnsArray", this.combinedIndividualAnsArray);
  }

  async updateFlagForMCQ(questionId, flag: boolean) {
    console.log("flag inside updateFlagForMCQ", flag);
    this.save_answer.get(questionId)[7] = flag;
    for (let i = 0; i < this.falseResponseIdsMCQ.length; i++) {
      if (flag == true) {
        this.prevSelectedAnswerArray.set(this.falseResponseIdsMCQ[i], [
          this.save_answer.get(this.falseResponseIdsMCQ[i])[0]
        ]);
      }
      this.save_answer.get(this.falseResponseIdsMCQ[i])[7] = flag;
    }
    this.save_individual_ans_array = [];
  }

  setNextTab(array) {
    console.log("inisde setnexttab", array, this.activeSubTab);
    this.activeSubTab = this.activeSubTab + 1;
    this.visitedComprehensionTab[array[this.activeSubTab].Id] = true;
    console.log(
      " this.visitedComprehensionTab inside setnexttab",
      this.visitedComprehensionTab[array[this.activeSubTab].Id]
    );
    this.prevQuestionId = this.selectedQuestionId;
    this.selectedQuestionId = `q${array[this.activeSubTab].Id}`;
    console.log(
      "questionid insuide setnexttab",
      this.prevQuestionId,
      this.selectedQuestionId
    );
    console.log("array[this.activeSubTab].Id", array[this.activeSubTab].Id);
    console.log("callIndividualSave inside setnexttab", this.essay_id);

    this.callIndividualSave();
    this.getCategory(array[this.activeSubTab].Id);
    this.router.navigate(["test", array[this.activeSubTab].Id]);
  }

  setPrevTab(array) {
    console.log("inisde setprevtab", array, this.activeSubTab);
    this.activeSubTab = this.activeSubTab - 1;
    this.visitedComprehensionTab[array[this.activeSubTab].Id] = true;
    console.log(
      " this.*visitedComprehensionTab inside set prevtab",
      this.visitedComprehensionTab[array[this.activeSubTab].Id]
    );
    this.prevQuestionId = this.selectedQuestionId;
    this.selectedQuestionId = `q${array[this.activeSubTab].Id}`;
    console.log("array[this.activeSubTab].Id", array[this.activeSubTab].Id);
    console.log("callIndividualSave inside setprevtab", this.essay_id);

    this.callIndividualSave();
    this.getCategory(array[this.activeSubTab].Id);

    this.router.navigate(["test", array[this.activeSubTab].Id]);
  }

  previousStep(questionIdarray, i) {
    this.previousValue = questionIdarray.get(
      `q${this.displayQuestionsArray[this.selectedIndex]}`
    );
    // this.button_click=false;
    this.selectedIndex = i;

    if (this.selectedIndex != 0) {
      this.selectedIndex = this.selectedIndex - 1;
      this.previousSelectedTabIndex.push(this.selectedIndex);
    }
    this.visited[i - 1] = true;
    this.visited[i] = true;
    this.visitedArray = i - 1;

    //this.visitedArray = i
    let success = !this.visitedArrays.some(item => item == this.visitedArray);
    {
      this.visitedArrays.push(this.visitedArray);
      _.uniq(this.visitedArrays);
    }
    if (success == true && this.visited_count > 0) {
      this.visited_count = this.visited_count - 1;
      this.visit = this.visit + 1;
      if (this.visit > 2) {
        this.stopblink = true;
      }
    }

    for (const [key, value] of this.submit.entries()) {
      this.fill[value[3]] = value[2];
    }
    this.prevQuestionId = this.selectedQuestionId;
    if (this.isArray(this.displayQuestionsArray[this.selectedIndex])) {
      this.selectedQuestionId = `q${
        this.displayQuestionsArray[this.selectedIndex][0].Id
      }`;
      console.log("array inside next click", this.selectedQuestionId);
    } else {
      this.selectedQuestionId = `q${
        this.displayQuestionsArray[this.selectedIndex].Id
      }`;
      console.log("not array inside next click", this.selectedQuestionId);
    }
    console.log("callIndividualSave inside prevstep", this.essay_id);

    this.callIndividualSave();
    if (this.isArray(this.displayQuestionsArray[this.selectedIndex])) {
      console.log(
        "inside array next",
        this.displayQuestionsArray[this.selectedIndex][0].Id
      );
      this.visitedComprehensionTab[
        this.displayQuestionsArray[this.selectedIndex][0].Id
      ] = true;
      console.log(
        " this.*visitedComprehensionTab inside prevstep",
        this.visitedComprehensionTab
      );

      this.activeSubTab = 0;
      this.getCategory(
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex][0].Id}`
        )
      );
      this.router.navigate([
        "test",
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex][0].Id}`
        )
      ]);
    } else {
      console.log("inside not array next");

      this.getCategory(
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex].Id}`
        )
      );
      this.router.navigate([
        "test",
        questionIdarray.get(
          `q${this.displayQuestionsArray[this.selectedIndex].Id}`
        )
      ]);
    }
  }

  // submit answers in user_answer table(all mcq's)

  evaluateTest() {
    this.submit_test();
    setTimeout(() => {
    
      console.log("set time out inside")
     }, 2000); 
  }
  submit_test() {
    this.isLoading = true;
    console.log("Array.from(this.save_essay)", Array.from(this.save_essay));
    console.log("length", Array.from(this.save_essay).length);
    // if (this.save_essay) {
    if (Array.from(this.save_essay).length > 0) {
      console.log("yes");
      this.save_essayanswer(false);
    } else {
      console.log("no");
    }
    console.log("clicked yes buutton submitted section 1", this.countDown);
    this.end_time();
    console.log("after clear 4", this.sectioncount);
    console.log("essay******", this.save_essay);

    //alert('submitans')
    if (this.sectioncount === null) {
      this.sectioncount = 0;
    }

    this.sectioncount++;
    localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));

    this.category_start_time = sessionStorage.getItem("Start_Time");
    this.category_time.end_time = this.end_button;
    this.category_time.start_time = this.category_start_time;
    this.category_time.category_id = this.questions[0].Section_Id;
    this.category_time.user_id = sessionStorage.getItem("id");
    console.log("this.category_time 5", this.category_time);
    this.section_time.end_time = this.end_button;
    this.section_time.start_time = sessionStorage.getItem("Start_Time");
    this.section_time.section_name = localStorage.getItem("Section_Name");
    this.section_time.user_id = sessionStorage.getItem("id");
    this.section_time.email = sessionStorage.getItem("email");
    console.log("myTime 6", this.myTime, this.time, this.timer_alert);
    clearTimeout(this.myTime);
    clearTimeout(this.time_to_capture);
    console.log(
      "myTime after clear 1   7",
      this.myTime,
      this.time,
      this.timer_alert
    );
    this.myTime = null;
    this.time_to_capture = null;
    console.log(
      "myTime after clear 2   8",
      this.myTime,
      this.time,
      this.timer_alert
    );
    console.log("timings 9", this.timings, this.time, this.timer_alert);
    clearTimeout(this.timings);
    console.log(
      "timings after clear 1 10",
      this.timings,
      this.time,
      this.timer_alert,
      this.counter,
      this.countDown
    );
    this.timings = null;
    this.counter = null;
    this.countDown = null;
    this.time = null;
    this.timer_alert = null;
    console.log(
      "timings after clear 2   11",
      this.timings,
      this.time,
      this.timer_alert,
      this.counter,
      this.countDown
    );
    // console.log("category_time",this.category_time)
    // console.log("this.questions[0].Section_Id",this.questions[0].Section_Id)
    localStorage.setItem(
      `${this.category_time.user_id}[${this.questions[0].Section_Id}]`,
      "completed"
    );
    localStorage["section_button" + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem(
      "section_button" + this.questions[0].Section_Id
    );

    // console.log("this.save_answer",this.save_answer)

    localStorage["targetSection" + this.questions[0].Section_Id] = 0;
    var tempp = localStorage.getItem(
      "targetSection" + this.questions[0].Section_Id
    );
    localStorage["section_button" + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem(
      "section_button" + this.questions[0].Section_Id
    );
    console.log("this.save_answer****", this.save_answer);
    this.submit = this.save_answer;
    this.submit.forEach((array, key) => {
      array.splice(-1, 1);
    });
    this.stopBothVideoAndAudio(this.video.nativeElement);

    this.quest.submit(this.submit).subscribe(
      async data => {
       this.isLoading = false;
        console.log("data.code inside logicaltest 2   12", data.code);
        if (data.code === 200) {
          console.log("data.code is 200 13");
          Swal.fire({
            title: "Success",
            text: "Answers Saved Successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonText: "OK"
          }).then(result => {
            if (result.isConfirmed) {
            }
          });
        } else if (data.code === 400) {
          this.isLoading = false;
          Swal.fire({
            title: "Alert",
            text: data.failed,
            icon: "warning",
            showCancelButton: false,
            confirmButtonText: "OK"
          }).then(result => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          });
        }
      
      },
      err => {
        //console.error(err);
      }
    );
    console.log("14**************");

    this.send_time();
    console.log("17****** after send_tume");

    this.sectiontime();
    console.log("20****** after section_time");

    this.exitFullScreen();
    console.log("22****** after fullscreen");

    // this.router.navigateByUrl('take_snapshot', { state: { value:'section' } })
    this.router.navigateByUrl("section");
  }

  async stopBothVideoAndAudio(stream) {
    console.log("inside stopBothVideoAndAudio", stream);
    stream.getTracks().forEach(function(track) {
      console.log("track", track);
      if (track.readyState == "live") {
        console.log("inside live");
        track.stop();
      }
    });
  }

  async sectiontime() {
    console.log("18******");

    // alert("sendtime")
    this.quest.section_time(this.section_time).subscribe(
      async data => {
        console.log("19******", data);
      },

      err => {
        //console.error(err);
      }
    );
  }

  //Save section time
  async send_time() {
    console.log("15*****");
    // alert("sendtime")
    this.quest
      .cate_time(this.category_time, this.userId, this.schedule_id, this.email)
      .subscribe(
        async data => {
          console.log("16******", data);
        },

        err => {
          //console.error(err);
        }
      );
  }

  //submit answers
  async end_test() {
    this.end_time();
    // clearInterval(this.intervalId);
    if (this.sectioncount === null) {
      this.sectioncount = 0;
    }
    this.sectioncount++;

    localStorage.setItem("section_counter", JSON.stringify(this.sectioncount));
    this.category_start_time = sessionStorage.getItem("Start_Time");
    this.category_time.end_time = this.end_button;
    this.category_time.start_time = this.category_start_time;
    this.category_time.category_id = this.questions[0].Section_Id;
    this.category_time.user_id = sessionStorage.getItem("id");
    localStorage.setItem(
      `${this.category_time.user_id}[${this.questions[0].Section_Id}]`,
      "completed"
    );
    localStorage["section_button" + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem(
      "section_button" + this.questions[0].Section_Id
    );

    this.section_time.end_time = this.end_button;
    this.section_time.start_time = sessionStorage.getItem("Start_Time");
    this.section_time.section_name = localStorage.getItem("Section_Name");
    this.section_time.user_id = sessionStorage.getItem("id");
    this.section_time.email = sessionStorage.getItem("email");

    localStorage["targetSection" + this.questions[0].Section_Id] = 0;
    var tempp = localStorage.getItem(
      "targetSection" + this.questions[0].Section_Id
    );
    localStorage["section_button" + this.questions[0].Section_Id] = 0;
    var arr = localStorage.getItem(
      "section_button" + this.questions[0].Section_Id
    );

    this.submit = this.save_answer;

    const data = await this.quest.submit(this.submit).toPromise();

    this.send_time();
    this.exitFullScreen();
    this.sectiontime();
    this.router.navigateByUrl("section");

    //this.modalService.dismissAll();
  }

  showImagePreview(questionImage) {
    let ngbModalOptions: NgbModalOptions = {
      size: "lg"
    };

    this.modal.open(this.modalImagePreview, ngbModalOptions);
    this.currentThumbnail = questionImage;
  }
  //capture right click event and display warning msg
  @HostListener("contextmenu", ["$event"])
  onRightClick(event) {
    event.preventDefault();
    const modalRef = this.modal.open(this.modalRightClick);
    setTimeout(() => {
      modalRef.close(this.modalContent);
    }, 3000);
    setTimeout(() => {
      modalRef.close(this.modalRightClick);
    }, 3000);
  }

  //  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
  //     alert("Escape pressed!!");
  // }

  //Track fullscreen change
  @HostListener("document:fullscreenchange", ["$event"])
  @HostListener("document:webkitfullscreenchange", ["$event"])
  @HostListener("document:mozfullscreenchange", ["$event"])
  @HostListener("document:MSFullscreenChange", ["$event"])
  fullscreenmode(event) {
    event.preventDefault();
    console.log("inside fullscreen event");

    if (window.innerHeight == screen.height) {
      console.log("inisde innerHeight", window.innerHeight, screen.height);
    }
    console.log("toggleClass", this.toggleClass);

    if (this.toggleClass == "ft-minimize") {
      console.log("insiode if");
      this.toggleClass = "ft-maximize";

      let ngbModalOptions: NgbModalOptions = {
        backdrop: "static",
        keyboard: false
      };

      //Open modal on pressing escape
      console.log("Open modal on pressing escape");
      this.modalCafe = this.modal.open(this.modalContent, ngbModalOptions);
      this.escape_count = this.escape_count + 1;
      if (this.escape_count > 6 || this.popupcounter > 6) {
        this.modalCafe.close(this.modalContent);
        clearTimeout(this.escapetime);
        this.escapetime = 0;
        this.n = JSON.parse(localStorage.getItem("on_load_counter"));
        localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
        if (
          this.questions[0].type_name != "None" &&
          this.questions[0].type_name != "Algorithm"
        ) {
          console.log("inside not equal");
          this.submit_test();
        }
        if (
          this.questions[0].type_name == "None" ||
          this.questions[0].type_name == "Algorithm"
        ) {
          console.log("inside this loop", this.essay_str);
          this.save_essayanswer(true);
        }
        this.final();
        this.modalCafe.close(this.modalContent);
        this.router.navigateByUrl("final");
      }
      // console.log("to show modal")
      setTimeout(() => {
        clearTimeout(this.escapetime);
        this.escapetime = 0;

        if (this.buttonclick == false) {
          this.modalCafe.close(this.modalContent);

          this.n = JSON.parse(localStorage.getItem("on_load_counter"));
          localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
          if (
            this.questions[0].type_name != "None" ||
            this.questions[0].type_name != "Algorithm"
          ) {
            this.submit_test();
          }
          if (
            this.questions[0].type_name == "None" ||
            this.questions[0].type_name == "Algorithm"
          ) {
            this.save_essayanswer(true);
          }
          this.modalCafe.close(this.modalContent);
          this.final();
          this.router.navigateByUrl("final");
        }
      }, this.escapetime);
    } else {
      console.log("inside else");
      this.toggleClass = "ft-minimize";
    }
  }

  //endtest for malpracticed users
  final() {
    localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
    this.n = 0;
    localStorage.setItem("section_counter", JSON.stringify(this.zero));

    this.user_logon_time = localStorage.getItem("Logon time");
    this.todaysDataTime = formatDate(this.today, "hh:mm:ss", "en-US", "+0530");

    this.user_loggoff_time = this.todaysDataTime;

    this.islogged.login_time = this.user_logon_time;
    this.islogged.logoff_time = this.user_loggoff_time;
    var schedule_master = sessionStorage.getItem("Schedule_Master_Id");

    this.Endtest.endtest(this.islogged, this.userId, schedule_master).subscribe(
      data1 => {
        this.logged = true;
        this.evaluate();
      },
      err => {}
    );
  }

  //evaluate malpracticed users
  evaluate() {
    console.log("inside evaluate**", this.userId, this.schedule_id);

    this.evaluate_user.evaluate(this.userId, this.schedule_id).subscribe(
      data => {
        //this.end_time();
      },
      err => {
        //console.error(err);
      }
    );
  }

  //Open fullscreen
  openFullscreen() {
    this.buttonclick = true;
    if (this.elem.requestFullscreen) {
      this.elem.requestFullscreen();
    } else if (this.elem.mozRequestFullScreen) {
      /* Firefox */
      this.elem.mozRequestFullScreen();
    } else if (this.elem.webkitRequestFullscreen) {
      /* Chrome, Safari and Opera */
      this.elem.webkitRequestFullscreen();
    } else if (this.elem.msRequestFullscreen) {
      /* IE/Edge */
      this.elem.msRequestFullscreen();
    }
  }

  //exitfullscreen
  exitFullScreen() {
    console.log("21******");
    

    const document: any = window.document;
    if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }

  // Observable to collect information from an api
  fetchData() {
    console.log("Terminate User Route");
    this.check_loggedin.Test_Taker_User_Id = sessionStorage.getItem("id");
    this.check_loggedin.schedule_id = sessionStorage.getItem("Schedule_Id");
    this.Endtest.checkisLogged(this.check_loggedin).subscribe(
      data => {
        if (data.results[0].Is_terminated == "YES") {
          console.log("Terminate User Route", data.results[0].Is_terminated);
          // clearInterval(this.intervalId);
          // clearImmediate(this.intervalId);
          clearTimeout(this.intervalId);
          this.n = JSON.parse(localStorage.getItem("on_load_counter"));
          localStorage.setItem("on_load_counter", JSON.stringify(this.zero));
          if (
            this.questions[0].type_name == "None" ||
            this.questions[0].type_name == "Algorithm"
          ) {
            // this.save_essayanswer_count();
            this.save_essayanswer(true);
          } else {
            // this.end_test();
            this.submit_test();
          }
          this.final();
          this.modalCafe.close(this.modalContent);
          this.router.navigateByUrl("final");
        }
      },
      err => {
        //console.error(err);
      }
    );
  }

  intervalId = setTimeout(() => {
    this.fetchData();
  }, 30000);

  bookmark(questionIdarray, i) {
    console.log("inside bookmark", questionIdarray, i);
    console.log(
      "*********",
      questionIdarray.get(`q${this.displayQuestionsArray[i].Id}`)
    );
    console.log(
      "this.book_mark",
      this.book_mark[
        questionIdarray.get(`q${this.displayQuestionsArray[i].Id}`)
      ]
    );
    this.bookmark_counter = this.bookmark_counter + 1;
    let questionId;
    if (this.isArray(this.displayQuestionsArray[i]))
      questionId = `q${this.displayQuestionsArray[i][0].Id}`;
    else questionId = `q${this.displayQuestionsArray[i].Id}`;

    console.log("questionId", questionId);
    this.book_mark[questionIdarray.get(questionId)] = true;
    //  this.book_mark[questionIdarray[i]] = true;
  }

  remove_bookmark(questionIdarray, i) {
    console.log("remove bookmark", questionIdarray, i);
    console.log(
      "this.book_mark",
      this.book_mark[
        questionIdarray.get(`q${this.displayQuestionsArray[i].Id}`)
      ]
    );

    this.bookmark_counter = this.bookmark_counter - 1;
    let questionId;
    if (this.isArray(this.displayQuestionsArray[i]))
      questionId = `q${this.displayQuestionsArray[i][0].Id}`;
    else questionId = `q${this.displayQuestionsArray[i].Id}`;

    console.log("questionId", questionId);
    this.book_mark[questionIdarray.get(questionId)] = false;

    // this.book_mark[questionIdarray[i]] = false;
  }

  setActiveSubTab(index: number, row) {
    console.log("inside setActiveSubTab", index, row);
    // if(row.selected){
    //   console.log("selected")
    // this.comprehensionTabColor[row.Id] = '#F9C118'
    // }else{
    //   console.log("nott seleceytd")
    // }
    this.prevQuestionId = this.selectedQuestionId;
    this.selectedQuestionId = `q${row.Id}`;
    console.log(
      "questionid insuide setactivesubtab",
      this.prevQuestionId,
      this.selectedQuestionId
    );
    this.activeSubTab = index;
    this.visitedComprehensionTab[row.Id] = true;
    console.log(
      "this.*visitedComprehensionTab inside setactive subtab",
      this.visitedComprehensionTab[row.Id]
    );
    console.log("callIndividualSave inside setactivetab", this.essay_id);

    this.callIndividualSave();
    this.getCategory(row.Id);
    this.router.navigate(["test", row.Id]);
  }

  isArray(item: any): boolean {
    return Array.isArray(item);
  }

  async setDefaultCount() {
    console.log("in set default count", this.countOfCallingDefaultCounter);
    if (this.countOfCallingDefaultCounter === 1) {
      const arrayDisplay = this.displayQuestionsArray;
      console.log(arrayDisplay);
      if (arrayDisplay.length !== 0) {
        let index = 0;
        for (const row of arrayDisplay) {
          console.log(this.currentCategoryQuestionlength, "*******unanswered");

          if (this.isArray(row)) {
            let mcqCount = 0;
            let ftVisitedCount = 0;
            let selectedComprehensionIndex = 0;
            let anyOneVisted = 0;
            let comprehensionCollection = [];
            let totalCount = 0;

            for (const item of row) {
              console.log("length of row***********", row.length);

              this.comprehensionQuestionsArray.map((data, index) => {
                data.map(selectedComp => {
                  if (item.Id == selectedComp.Id) {
                    console.log("data*****", data);

                    selectedComprehensionIndex = index;
                  }
                });
              });

              if (item.type_name == "Comprehension With MCQ") {
                comprehensionCollection.push(item.type_name);

                console.log("inside comprehension with mcq", mcqCount);
                if (item.selected !== null && item.selected !== undefined) {
                  if (index != 0) {
                    anyOneVisted = anyOneVisted + 1;
                  }
                  if (anyOneVisted === 1 && index !== 0) {
                    this.visit = this.visit + 1;
                    this.visited_count = this.visited_count - 1;
                  }

                  mcqCount = mcqCount + 1;
                  console.log(
                    selectedComprehensionIndex,
                    "!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!"
                  );

                  this.filter[item.Id] = true;
                  this.fill[item.Id] = item.selected;
                  this.esarr[item.Id] = 1;

                  if (mcqCount >= row.length) {
                    console.log(
                      "inside count equal or greater",
                      this.unanswered
                    );
                    this.comprehensionUnanswered =
                      this.comprehensionUnanswered - 1;
                    this.answered = this.answered + 1;
                    this.unanswered = this.unanswered - 1;
                    this.answeredAllComprehensionQns[
                      selectedComprehensionIndex
                    ] = true;

                    this.flagForCount = true;
                  }
                }
              }

              if (item.type_name == "Comprehension With Free Text") {
                comprehensionCollection.push(item.type_name);
                console.log(
                  "inside comprehension with free text",
                  this.comprehensionQuestionsArray
                );

                if (item.textValue!==null && item.textValue!==undefined) {
                  if (index != 0) {
                    anyOneVisted = anyOneVisted + 1;
                  }

                  if (anyOneVisted === 1) {
                    this.visit = this.visit + 1;
                    this.visited_count = this.visited_count - 1;
                  }

                  this.esarr[item.Id] = 1;
                  this.filter[item.Id] = true;
                  this.roughspace_flag[item.Id] = true;

                  console.log(selectedComprehensionIndex);
                  ftVisitedCount = ftVisitedCount + 1;
                  if (ftVisitedCount >= row.length) {
                    this.comprehensionUnanswered =
                      this.comprehensionUnanswered - 1;
                    this.answered = this.answered + 1;
                    this.unanswered = this.unanswered - 1;
                    this.answeredAllComprehensionQnsFreeText[
                      selectedComprehensionIndex
                    ] = true;
                  }
                }
              }

              console.log(
                comprehensionCollection,
                "comprehension collection at intial stage"
              );

              if (
                comprehensionCollection.includes(
                  "Comprehension With Free Text"
                ) &&
                comprehensionCollection.includes("Comprehension With MCQ")
              ) {
                console.log("inside comprehension contain both");
                totalCount = mcqCount + ftVisitedCount;
                this.isComprehensionContainBoth = true;

                if (totalCount >= row.length) {
                  this.answered = this.answered + 1;
                  this.unanswered = this.unanswered - 1;
                  this.comprehensionUnanswered =
                    this.comprehensionUnanswered - 1;
                  this.answerAllComprehension[
                    selectedComprehensionIndex
                  ] = true;
                }
              }
            }
          } else {
            console.log("inside not row is not an array");
            if (
              (row.selected !== null && row.selected !== undefined) ||
              (row.textValue !== null && row.textValue !== undefined)
            ) {
              // Your code logic here

              console.log("inside ft types is answered");

              if (
                row.type_name === "Multiple Choice" ||
                row.type_name === "MCQ With Free Text"
              ) {
                console.log("inside mcq with free text");
                this.answered = this.answered + 1;
                this.unanswered = this.unanswered - 1;
                this.MCQUnanswered = this.MCQUnanswered - 1;

                this.esarr[row.Id] = 1;
                this.filter[row.Id] = true;

                if (index !== 0) {
                  this.visit = this.visit + 1;
                  this.visited_count = this.visited_count - 1;
                }
              } else {
                console.log("inside free text types");
                this.answered = this.answered + 1;
                this.unanswered = this.unanswered - 1;
                this.esarr[row.Id] = 1;
                this.filter[row.Id] = true;
                this.roughspace_flag[row.Id] = true;

                if (index !== 0) {
                  this.visit = this.visit + 1;
                  this.visited_count = this.visited_count - 1;
                }
              }
            }
          }
          index++;
        }
      }
    }
  }

  // async populateDisplayQues() {
  //   this.displayQuestionsArray = [];
  //   this.comprehensionQuestionsArray = [];
  //   this.compArray = [];

  //   let q_url = "initial";

  //   // this.questions=await this.getQuestion()

  //   for (let i = 0; i < this.questions.length; i++) {
  //     if (
  //       this.questions[i].type_name == "Comprehension With MCQ" ||
  //       this.questions[i].type_name == "Comprehension With Free Text"
  //     ) {
  //       if (q_url == "initial") {
  //         this.compArray.push(this.questions[i]);
  //         q_url = this.questions[i].q_url;
  //       } else {
  //         if (this.questions[i].q_url == q_url) {
  //           console.log("qurl is same");
  //           this.compArray.push(this.questions[i]);
  //           if (
  //             (this.questions[i + 1] &&
  //               this.questions[i + 1].type_name != "Comprehension With MCQ" &&
  //               this.questions[i + 1].type_name !=
  //                 "Comprehension With Free Text") ||
  //             i == this.questions.length - 1
  //           ) {
  //             console.log("compArray in final", i, this.compArray);
  //             this.displayQuestionsArray.push(this.compArray);
  //             this.comprehensionQuestionsArray.push(this.compArray);
  //             q_url = "initial";
  //             this.compArray = [];
  //           }
  //         } else {
  //           console.log("comp array pushed");
  //           this.displayQuestionsArray.push(this.compArray);
  //           this.comprehensionQuestionsArray.push(this.compArray);
  //           this.compArray = [];
  //           // console.log("q_url not equal")
  //           this.compArray.push(this.questions[i]);
  //           // console.log("compArray initial",this.compArray)
  //           q_url = this.questions[i].q_url;
  //         }
  //       }
  //     } else {
  //       console.log("no coprehension qa");
  //       this.displayQuestionsArray.push(this.questions[i]);
  //     }
  //   }
  //   console.log("end of for");
  //   console.log("this.displayQuestionsArray", this.displayQuestionsArray);

  //   this.comprehensionUnanswered = this.comprehensionQuestionsArray.length;
  //   console.log("comprehensionUnanswered", this.comprehensionUnanswered);
  //   this.total = this.displayQuestionsArray.length;
  //   console.log("this.compArray", this.compArray);

  //   return this.displayQuestionsArray;
  // }
  async populateDisplayQues() {
  this.displayQuestionsArray = [];
  this.comprehensionQuestionsArray = [];

  const compMap = new Map<string, any[]>();

  // 1. Group all comprehension questions by q_url
  for (const q of this.questions) {
    if (
      q.type_name === "Comprehension With MCQ" ||
      q.type_name === "Comprehension With Free Text"
    ) {
      if (!compMap.has(q.q_url)) {
        compMap.set(q.q_url, []);
      }
      compMap.get(q.q_url)!.push(q);
    }
  }

  // 2. Build displayQuestionsArray preserving original order
  const usedCompUrls = new Set<string>();

  for (const q of this.questions) {
    if (
      q.type_name === "Comprehension With MCQ" ||
      q.type_name === "Comprehension With Free Text"
    ) {
      if (!usedCompUrls.has(q.q_url)) {
        const group = compMap.get(q.q_url)!;
        this.displayQuestionsArray.push(group);
        this.comprehensionQuestionsArray.push(group);
        usedCompUrls.add(q.q_url);
      }
    } else {
      this.displayQuestionsArray.push(q);
    }
  }

  this.comprehensionUnanswered = this.comprehensionQuestionsArray.length;
  this.total = this.displayQuestionsArray.length;

  return this.displayQuestionsArray;
}

}

//Time Countdown
@Pipe({
  name: "formatTime"
})
export class FormatTimePipe implements PipeTransform {
  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);

    return (
      ("00" + minutes).slice(-2) +
      ":" +
      ("00" + Math.floor(value - minutes * 60)).slice(-2)
    );
  }
}
